import { useState, useEffect } from "react";
// ★U8(cmd-po_1109): sip-stepper共通部品
import { SipStepper } from "../common/SipStepper";

// ui
import {
  Button,
  Typography,
  Modal,
  Box,
  Paper,
  MenuItem,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  useMediaQuery,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import EmailIcon from "@mui/icons-material/Email";
// cmd-po_1247: 自前✕撤去に伴い CloseIcon import を退役
import CheckIcon from "@mui/icons-material/Check";

// QRコード生成
import { QRCodeCanvas } from "qrcode.react";

// InterFace
import { DataColumn } from "../../config/dataInterface";
import { getOneYearListDetail } from "../../lib/other";
import { LIST_POST, LIST } from "../../config/const";

import { CONST } from "../../config/const";
import {
  DataDetailRowContractNumberMonths,
  DataDetailRowCustomerInfo,
  DataDetailRowElse,
} from "../detail/DataDetailComponent";

// API
import { getTossUpClosingForm } from "../../api/tossUp";
import { getAddress } from "../../api/address";
import {
  getPresignedPostPicture,
  postPresignedPost,
} from "../../api/presignedURL";

// jotai
import { useAtomValue } from "jotai";
import { AppAtoms } from "../../lib/store";

// 共有部品
import { LeaveGuard } from "../list/LeaveGuard";
// ★ cmd-po_1137: po-form 共通部品
import { PoField, PoLabel, PoTextField, PoSelect, PoCheckbox, PoHelper, PoSplit, PoCheckGroup, PoCheckRow, PoFileDrop, PO_FORM_MSG, isValidMail, isValidTel, isValidZip } from "../common/PoForm";

interface InputFreeTextProps {
  addData: {
    addStatus:
      | null
      | "loading"
      | "change_account"
      | "open"
      | "product"
      | "entry_method"
      | "site_path"
      | "contract"
      | "copyTossUp"
      | "sms_success";
    key: { [key: string]: string };
    toss_up_status: number | null;
    outSiteEntry: 0 | 1;
    outsideSiteUrl: string;
    outsideServiceUrl: string;
    viewOutsideServiceUrl: 0 | 1;
    closing_memo: string;
    closing_failed_memo: string;
    hope_call_date: string;
    hope_call_time_kind: number | null;
    hope_call_time: string;
    return_call_memo: string;
    copy_toss_up: 0 | 1;
    productId: number | null;
    productName: string;
    have_entry_form: number | null;
    site_path_list: string[];
    site_path: string;
    outsideMessageType: number | null;
    phone_number: string;
    customer_name: string;
    customer_company_name: string;
    servicePlanName: string;
    serviceContentNameList: string[];
    serviceCampaignPulldownName: string;
    serviceCampaignCheckboxName: string[];
    servicePaymentMethodName: string;
    serviseCustomerListID: string;
    pullDownServiceName: string;
    checkBoxServiceNames: string;
    smsMessagePatternID: number | null;
    customerInfo: { [key: string]: string | string[] };
    changeAccount: 0 | 1;
    changeAccountID: number | null;
  };
  setAddData: React.Dispatch<
    React.SetStateAction<{
      addStatus:
        | null
        | "loading"
        | "change_account"
        | "open"
        | "product"
        | "entry_method"
        | "site_path"
        | "contract"
        | "copyTossUp"
        | "sms_success";
      key: { [key: string]: string };
      toss_up_status: number | null;
      outSiteEntry: 0 | 1;
      outsideSiteUrl: string;
      outsideServiceUrl: string;
      viewOutsideServiceUrl: 0 | 1;
      closing_memo: string;
      closing_failed_memo: string;
      hope_call_date: string;
      hope_call_time_kind: number | null;
      hope_call_time: string;
      return_call_memo: string;
      copy_toss_up: 0 | 1;
      productId: number | null;
      productName: string;
      phone_number: string;
      have_entry_form: number | null;
      site_path_list: string[];
      site_path: string;
      outsideMessageType: number | null;
      customer_name: string;
      customer_company_name: string;
      servicePlanName: string;
      serviceContentNameList: string[];
      serviceCampaignPulldownName: string;
      serviceCampaignCheckboxName: string[];
      servicePaymentMethodName: string;
      serviseCustomerListID: string;
      pullDownServiceName: string;
      checkBoxServiceNames: string;
      smsMessagePatternID: number | null;
      customerInfo: { [key: string]: string | string[] };
      changeAccount: 0 | 1;
      changeAccountID: number | null;
    }>
  >;
  uniqueOption: { [key: string]: string | number | string[] };
  addressOptionName: string;
}

function InputFreeText(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  return (
    <>
      <PoTextField
        disabled={uniqueOption.change_value_conf === 1}
        id="textFieldId"
        fullWidth
        value={addData.customerInfo[uniqueOption.option_name as string]}
        onChange={async (e) => {
          let customerInfo = addData.customerInfo;
          customerInfo[uniqueOption.option_name as string] = e.target.value;
          setAddData((addData) => ({
            ...addData,
            customerInfo,
          }));
        }}
        multiline={uniqueOption.multi_text_flg === 1}
        rows={uniqueOption.multi_text_flg === 1 ? 4 : undefined}
      />
      {uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextTel(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const [input3, setInput3] = useState("");
  const [touched, setTouched] = useState(false);
  const invalid = touched && (input1 !== "" || input2 !== "" || input3 !== "") && !isValidTel(`${input1}-${input2}-${input3}`);
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      input3 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 3
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split("-");
      setInput1(parts[0]);
      setInput2(parts[1]);
      setInput3(parts[2]);
    } else {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] =
        input1 + "-" + input2 + "-" + input3;
      const phone_number = input1 + "-" + input2 + "-" + input3;
      setAddData((addData) => ({
        ...addData,
        phone_number,
        customerInfo,
      }));
    }
  }, [input1, input2, input3]);
  return (
    <>
      <PoSplit>
        <PoTextField
          id="textFieldIdTel1"
          value={input1}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput1(inputValue);
            }
          }}
        />
        <Box sx={{ flex: "0 0 auto" }}>-</Box>
        <PoTextField
          id="textFieldIdTel2"
          value={input2}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput2(inputValue);
            }
          }}
        />
        <Box sx={{ flex: "0 0 auto" }}>-</Box>
        <PoTextField
          id="textFieldIdTel3"
          value={input3}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput3(inputValue);
            }
          }}
        />
      </PoSplit>
      {invalid ? (
        <PoHelper error>{PO_FORM_MSG.format}</PoHelper>
      ) : uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextFormTel(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const [input3, setInput3] = useState("");
  const [touched, setTouched] = useState(false);
  const invalid = touched && (input1 !== "" || input2 !== "" || input3 !== "") && !isValidTel(`${input1}-${input2}-${input3}`);
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      input3 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 3
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split("-");
      setInput1(parts[0]);
      setInput2(parts[1]);
      setInput3(parts[2]);
    } else {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] =
        input1 + "-" + input2 + "-" + input3;
      setAddData((addData) => ({
        ...addData,
        customerInfo,
      }));
    }
  }, [input1, input2, input3]);
  return (
    <>
      <PoSplit>
        <PoTextField
          id="textFieldIdTel1"
          value={input1}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput1(inputValue);
            }
          }}
        />
        <Box sx={{ flex: "0 0 auto" }}>-</Box>
        <PoTextField
          id="textFieldIdTel2"
          value={input2}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput2(inputValue);
            }
          }}
        />
        <Box sx={{ flex: "0 0 auto" }}>-</Box>
        <PoTextField
          id="textFieldIdTel3"
          value={input3}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput3(inputValue);
            }
          }}
        />
      </PoSplit>
      {invalid ? (
        <PoHelper error>{PO_FORM_MSG.format}</PoHelper>
      ) : uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextName(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 2
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split(" ");
      setInput1(parts[0]);
      setInput2(parts[1]);
    } else {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] = input1 + " " + input2;
      const customer_name = input1 + " " + input2;
      setAddData((addData) => ({
        ...addData,
        customer_name,
        customerInfo,
      }));
    }
  }, [input1, input2]);
  return (
    <>
      <PoSplit>
        <PoTextField id="textFieldIdName1" value={input1} onChange={async (e) => setInput1(e.target.value)} />
        <PoTextField id="textFieldIdName2" value={input2} onChange={async (e) => setInput2(e.target.value)} />
      </PoSplit>
      {uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextCompanyName(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  return (
    <>
      <PoTextField
        disabled={uniqueOption.change_value_conf === 1}
        id="textFieldId"
        fullWidth
        value={addData.customerInfo[uniqueOption.option_name as string]}
        onChange={async (e) => {
          let customerInfo = addData.customerInfo;
          customerInfo[uniqueOption.option_name as string] = e.target.value;
          const customer_company_name = e.target.value;
          setAddData((addData) => ({
            ...addData,
            customerInfo,
            customer_company_name,
          }));
        }}
        multiline={uniqueOption.multi_text_flg === 1}
        rows={uniqueOption.multi_text_flg === 1 ? 4 : undefined}
      />
      {uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextZipCode(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const [touched, setTouched] = useState(false);
  const invalid = touched && (input1 !== "" || input2 !== "") && !isValidZip(`${input1}-${input2}`);
  useEffect(() => {
    async function getAddressText(zipCode: string) {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] = zipCode;
      setAddData((addData) => ({
        ...addData,
        customerInfo,
      }));

      const address = await getAddress(zipCode);
      customerInfo[addressOptionName] = address;
      setAddData((addData) => ({
        ...addData,
        customerInfo,
      }));
    }
    if (
      input1 == "" &&
      input2 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 2
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split("-");
      setInput1(parts[0]);
      setInput2(parts[1]);
    } else {
      const zipCode = input1 + "-" + input2;
      if (input1.length === 3 && input2.length === 4) {
        getAddressText(zipCode);
      } else {
        let customerInfo = addData.customerInfo;
        customerInfo[uniqueOption.option_name as string] = zipCode;
        setAddData((addData) => ({
          ...addData,
          customerInfo,
        }));
      }
    }
  }, [input1, input2]);
  return (
    <>
      <PoSplit>
        <PoTextField
          id="textFieldIdZipCode1"
          value={input1}
          inputProps={{ maxLength: 3 }}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue) && inputValue.length <= 3) {
              setInput1(inputValue);
            }
          }}
        />
        <Box sx={{ flex: "0 0 auto" }}>-</Box>
        <PoTextField
          id="textFieldIdZipCode2"
          value={input2}
          inputProps={{ maxLength: 4 }}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue) && inputValue.length <= 4) {
              setInput2(inputValue);
            }
          }}
        />
      </PoSplit>
      {invalid ? (
        <PoHelper error>{PO_FORM_MSG.format}</PoHelper>
      ) : uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextSpace(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 2
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split(" ");
      setInput1(parts[0]);
      setInput2(parts[1]);
    } else {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] = input1 + " " + input2;
      setAddData((addData) => ({
        ...addData,
        customerInfo,
      }));
    }
  }, [input1, input2]);
  return (
    <>
      <PoSplit>
        <PoTextField id="textFieldIdSpace1" value={input1} onChange={async (e) => setInput1(e.target.value)} />
        <PoTextField id="textFieldIdSpace2" value={input2} onChange={async (e) => setInput2(e.target.value)} />
      </PoSplit>
      {uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextMailAddress(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const [touched, setTouched] = useState(false);
  const invalid = touched && (input1 !== "" || input2 !== "") && !isValidMail(`${input1}@${input2}`);
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 2
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split("@");
      setInput1(parts[0]);
      setInput2(parts[1]);
    } else {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] = input1 + "@" + input2;
      setAddData((addData) => ({
        ...addData,
        customerInfo,
      }));
    }
  }, [input1, input2]);
  return (
    <>
      <PoSplit>
        <PoTextField
          id="textFieldIdmm1"
          value={input1}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => setInput1(e.target.value)}
        />
        <Box sx={{ flex: "0 0 auto" }}>@</Box>
        <PoTextField
          id="textFieldIdmm2"
          value={input2}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => setInput2(e.target.value)}
        />
      </PoSplit>
      {invalid ? (
        <PoHelper error>{PO_FORM_MSG.format}</PoHelper>
      ) : uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextHalfWidthNumber(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption } = props;
  return (
    <>
      <PoTextField
        disabled={uniqueOption.change_value_conf === 1}
        id="textFieldId"
        fullWidth
        value={addData.customerInfo[uniqueOption.option_name as string]}
        onChange={async (e) => {
          const inputValue = e.target.value;
          if (!/^\d*$/.test(inputValue)) return;
          let customerInfo = addData.customerInfo;
          customerInfo[uniqueOption.option_name as string] = inputValue;
          setAddData((addData) => ({
            ...addData,
            customerInfo,
          }));
        }}
        inputProps={{ inputMode: "numeric", pattern: "\\d*" }}
      />
      {uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment}</PoHelper>
      ) : null}
    </>
  );
}

interface ClosingTossUpModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  cancellCloseModal: () => void;
  postAddData: (customerInfo: { [key: string]: string | string[] }) => void;
  addData: {
    addStatus:
      | null
      | "loading"
      | "change_account"
      | "open"
      | "product"
      | "entry_method"
      | "site_path"
      | "contract"
      | "copyTossUp"
      | "sms_success";
    key: { [key: string]: string };
    toss_up_status: number | null;
    outSiteEntry: 0 | 1;
    outsideSiteUrl: string;
    outsideServiceUrl: string;
    viewOutsideServiceUrl: 0 | 1;
    closing_memo: string;
    closing_failed_memo: string;
    hope_call_date: string;
    hope_call_time_kind: number | null;
    hope_call_time: string;
    return_call_memo: string;
    copy_toss_up: 0 | 1;
    productId: number | null;
    productName: string;
    phone_number: string;
    have_entry_form: number | null;
    site_path_list: string[];
    site_path: string;
    outsideMessageType: number | null;
    customer_name: string;
    customer_company_name: string;
    servicePlanName: string;
    serviceContentNameList: string[];
    serviceCampaignPulldownName: string;
    serviceCampaignCheckboxName: string[];
    servicePaymentMethodName: string;
    serviseCustomerListID: string;
    pullDownServiceName: string;
    checkBoxServiceNames: string;
    smsMessagePatternID: number | null;
    customerInfo: { [key: string]: string | string[] };
    changeAccount: 0 | 1;
    changeAccountID: number | null;
  };
  setAddData: React.Dispatch<
    React.SetStateAction<{
      addStatus:
        | null
        | "loading"
        | "change_account"
        | "open"
        | "product"
        | "entry_method"
        | "site_path"
        | "contract"
        | "copyTossUp"
        | "sms_success";
      key: { [key: string]: string };
      toss_up_status: number | null;
      outSiteEntry: 0 | 1;
      outsideSiteUrl: string;
      outsideServiceUrl: string;
      viewOutsideServiceUrl: 0 | 1;
      closing_memo: string;
      closing_failed_memo: string;
      hope_call_date: string;
      hope_call_time_kind: number | null;
      hope_call_time: string;
      return_call_memo: string;
      copy_toss_up: 0 | 1;
      productId: number | null;
      productName: string;
      phone_number: string;
      have_entry_form: number | null;
      site_path_list: string[];
      site_path: string;
      outsideMessageType: number | null;
      customer_name: string;
      customer_company_name: string;
      servicePlanName: string;
      serviceContentNameList: string[];
      serviceCampaignPulldownName: string;
      serviceCampaignCheckboxName: string[];
      servicePaymentMethodName: string;
      serviseCustomerListID: string;
      pullDownServiceName: string;
      checkBoxServiceNames: string;
      smsMessagePatternID: number | null;
      customerInfo: { [key: string]: string | string[] };
      changeAccount: 0 | 1;
      changeAccountID: number | null;
    }>
  >;
  contractProductList: {
    id: number;
    product_name: string;
    have_entry_form: number;
    site_path_list: string[];
  }[];
  selectServisePlanList: { service_name: string }[];
  setSelectServisePlanList: (value: { service_name: string }[]) => void;
  selectServiseContentList: { service_name: string }[];
  setSelectServiseContentList: (value: { service_name: string }[]) => void;
  selectServiseCampaignPulldownList: { service_name: string }[];
  setSelectServiseCampaignPulldownList: (
    value: { service_name: string }[],
  ) => void;
  selectServiseCampaignCheckboxList: { service_name: string }[];
  setSelectServiseCampaignCheckboxList: (
    value: { service_name: string }[],
  ) => void;
  selectServisePaymentList: { payment_method: string }[];
  setSelectServisePaymentList: (value: { payment_method: string }[]) => void;
  uniqueOptinList: { [key: string]: string | number | string[] }[];
  setUniqueOptinList: (
    value: { [key: string]: string | number | string[] }[],
  ) => void;
  addressOptionName: string;
  setAddressOptionName: (name: string) => void;
  postPictures: {
    [key: string]: File;
  };
  setPostPicture: (value: { [key: string]: File }) => void;
  putClosingFailed: () => void;
  copyClosingTossUp: () => void;
  setOnDataAddModalResult: (value: string) => void;
  editAuth: string[];
  dataColumn: DataColumn[];
  dataDetail: {
    [key: string]:
      | number
      | string
      | { [key: string]: string | number }[]
      | { [key: string]: string | string[] };
  } | null;
  dataDetailOption: {
    [key: string]: string | number;
  }[];
  accountCollaborateCompanySaleList?: {
    sale_company_id: number;
    sale_company_name: string;
    id: number;
    account_name: string;
  }[];
  accountColumn?: string;
  getFormFunction?: () => void;
}

export function ClosingTossUpModal(props: ClosingTossUpModalProps) {
  const {
    onModal,
    swCloseModal,
    cancellCloseModal,
    postAddData,
    addData,
    setAddData,
    contractProductList,
    selectServisePlanList,
    setSelectServisePlanList,
    selectServiseContentList,
    setSelectServiseContentList,
    selectServiseCampaignPulldownList,
    setSelectServiseCampaignPulldownList,
    selectServiseCampaignCheckboxList,
    setSelectServiseCampaignCheckboxList,
    selectServisePaymentList,
    setSelectServisePaymentList,
    uniqueOptinList,
    setUniqueOptinList,
    addressOptionName,
    setAddressOptionName,
    postPictures,
    setPostPicture,
    putClosingFailed,
    copyClosingTossUp,
    setOnDataAddModalResult,
    editAuth,
    dataColumn,
    dataDetail,
    dataDetailOption,
    accountCollaborateCompanySaleList,
    accountColumn,
    getFormFunction,
  } = props;
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);
  const loginUser = useAtomValue(AppAtoms.loginUser);

  // R38: 画面幅が狭い(<=1000px)ときは入力(左)/詳細(右)を1カラムで切り替える。
  //   isSmartPhone(App.tsx)の判定は変更しない=全画面に波及するため別軸(useMediaQuery)で判定。
  const isNarrow = useMediaQuery("(max-width:1000px)");
  // 狭幅時の表示ペイン(既定=入力)。モーダルを開いたとき入力へ戻す。
  const [narrowPane, setNarrowPane] = useState<"input" | "detail">("input");
  useEffect(() => {
    if (onModal) setNarrowPane("input");
  }, [onModal]);

  const [leaveGuardOpen, setLeaveGuardOpen] = useState(false);
  const [postPicturesError, setPostPicturesError] = useState<{[key: string]: string}>({});
  const hasStep1 = getFormFunction !== undefined;
  const acctName = (() => {
    if (addData.changeAccount === 1 && addData.changeAccountID !== null) {
      return (accountCollaborateCompanySaleList ?? []).find(
        (x) => x.id === addData.changeAccountID
      )?.account_name ?? "";
    }
    return loginUser?.username ?? "";
  })();

  const style = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "1280px",
    maxWidth: "calc(100vw - 32px)",
    maxHeight: "94vh",
    bgcolor: "background.paper",
    borderRadius: "var(--radius-lg, 14px)",
    boxShadow: "var(--shadow-elevated)",
    display: "flex",
    flexDirection: "column",
    zIndex: 310,
  };

  // 商材一覧検索用
  const [inputSerchProductName, setInputSerchProductName] = useState("");
  const [serchProductList, setSerchProductList] = useState<
    {
      id: number;
      product_name: string;
      have_entry_form: number;
      site_path_list: string[];
    }[]
  >([]);
  useEffect(() => {
    if (inputSerchProductName === "") {
      const serchProductList = contractProductList.filter(
        (product) =>
          product.have_entry_form === 1 || product.site_path_list.length > 0,
      );
      setSerchProductList(serchProductList);
    } else {
      const serchProductList = contractProductList.filter(
        (product) =>
          (product.have_entry_form === 1 ||
            product.site_path_list.length > 0) &&
          product.product_name.includes(inputSerchProductName),
      );
      setSerchProductList(serchProductList);
    }
  }, [contractProductList, inputSerchProductName]);

  // 外部ET用の変数
  const [outSidePullDownServiceNameList, setOutSidePullDownServiceNameList] =
    useState<{ service_name: string }[]>([]);
  const [outSideCheckBoxServiceNameList, setOutSideCheckBoxServiceNameList] =
    useState<{ service_name: string }[]>([]);
  const [smsMessagePatterns, setSmsMessagePatterns] = useState<
    {
      id: number;
      outside_sms_name: string;
      outside_sms_sender: string;
      outside_sms_body: string;
    }[]
  >([]);
  const [mailMessagePatterns, setMailMessagePatterns] = useState<
    {
      id: number;
      outside_sms_name: string;
      outside_sms_sender: string;
      outside_sms_title: string;
      outside_sms_body: string;
    }[]
  >([]);

  const [useMailAddressFlg, setUseMailAddressFlg] = useState(false);

  async function getProductInfo(
    productId: number,
    productName: string,
    outSiteEntry: 0 | 1,
    site_path: string,
  ) {
    setAddData((addData) => ({
      ...addData,
      addStatus: "loading",
    }));
    const {
      service_plan_data,
      service_content_data,
      service_campaign_pulldown_data,
      service_campaign_checkbox_data,
      service_payment_data,
      option_data,
      toss_up_option_data,
      outside_pull_down_service,
      outside_check_box_service,
      outside_option_data,
      outside_sms_patterns,
      outside_mail_patterns,
    } = await getTossUpClosingForm(
      productId,
      addData.key.id,
      outSiteEntry,
      site_path,
      addData.changeAccount,
      addData.changeAccountID,
    );
    if (outSiteEntry === 0) {
      // 内部エントリー
      if (service_plan_data.length === 0) {
        swCloseModal();
        setOnDataAddModalResult(
          "エントリー可能なプランが定義されていません。管理者に問い合わせてください。",
        );
      } else {
        setSelectServisePlanList(service_plan_data);
        setSelectServiseContentList(service_content_data);
        if (service_campaign_pulldown_data.length > 0) {
          setSelectServiseCampaignPulldownList([
            { service_name: "" },
            ...service_campaign_pulldown_data,
          ]);
        } else {
          setSelectServiseCampaignPulldownList(service_campaign_pulldown_data);
        }
        setSelectServiseCampaignCheckboxList(service_campaign_checkbox_data);
        setSelectServisePaymentList(service_payment_data);
        setUniqueOptinList(option_data);
        if (option_data.length > 0) {
          const customerInfo: {
            [key: string]: string | string[];
          } = option_data.reduce<{ [key: string]: string | string[] }>(
            (column, option) => {
              let option_value: string | string[] = "";
              // change_value_conf===1 は option_type0(default非空)前提
              if (option.change_value_conf === 1) {
                return { ...column, [option.option_name as string]: (option.option_default_value as string) ?? "" };
              }
              if (option.option_type === 0) {
                option_value = option.option_default_value as string;
                let tel_flg_option_name = "";
                let name_flg_option_name = "";
                let company_name_flg_option_name = "";
                let zip_code_flg_option_name = "";
                let address_flg_option_name = "";
                let mail_address_flg_option_name = "";
                toss_up_option_data.map((toss_up_option) => {
                  if (
                    toss_up_option.option_name === option.option_name &&
                    toss_up_option.option_type === 0
                  ) {
                    // 質問名が同じなら同じ値を挿入
                    if (
                      (option.option_name as string) in addData.customerInfo
                    ) {
                      option_value =
                        addData.customerInfo[option.option_name as string];
                    }
                  }
                  // 重複なしの各種フラグが同じなら質問名に関わらず同じ値を挿入
                  if (toss_up_option.tel_flg === 1) {
                    tel_flg_option_name = toss_up_option.option_name as string;
                  }
                  if (toss_up_option.name_flg === 1) {
                    name_flg_option_name = toss_up_option.option_name as string;
                  }
                  if (toss_up_option.company_name_flg === 1) {
                    company_name_flg_option_name =
                      toss_up_option.option_name as string;
                  }
                  if (toss_up_option.zip_code_flg === 1) {
                    zip_code_flg_option_name =
                      toss_up_option.option_name as string;
                  }
                  if (toss_up_option.address_flg === 1) {
                    address_flg_option_name =
                      toss_up_option.option_name as string;
                  }
                  if (toss_up_option.mail_address_flg === 1) {
                    mail_address_flg_option_name =
                      toss_up_option.option_name as string;
                  }
                });
                if (option.tel_flg === 1 && tel_flg_option_name != "") {
                  option_value = addData.customerInfo[tel_flg_option_name];
                }
                if (option.name_flg === 1 && name_flg_option_name != "") {
                  option_value = addData.customerInfo[name_flg_option_name];
                }
                if (
                  option.company_name_flg === 1 &&
                  company_name_flg_option_name != ""
                ) {
                  option_value =
                    addData.customerInfo[company_name_flg_option_name];
                }
                if (
                  option.zip_code_flg === 1 &&
                  zip_code_flg_option_name != ""
                ) {
                  option_value = addData.customerInfo[zip_code_flg_option_name];
                }
                if (option.address_flg === 1 && address_flg_option_name != "") {
                  option_value = addData.customerInfo[address_flg_option_name];
                }
                if (
                  option.mail_address_flg === 1 &&
                  mail_address_flg_option_name != ""
                ) {
                  option_value =
                    addData.customerInfo[mail_address_flg_option_name];
                }
                return {
                  ...column,
                  [option.option_name as string]: option_value,
                };
              } else if (option.option_type === 1) {
                toss_up_option_data.map((toss_up_option) => {
                  if (
                    toss_up_option.option_name === option.option_name &&
                    toss_up_option.option_type === 1
                  ) {
                    // 質問名が同じなら同じ値を挿入
                    if (
                      (option.option_name as string) in addData.customerInfo
                    ) {
                      let select_option_value = addData.customerInfo[
                        option.option_name as string
                      ] as string;
                      if (
                        (option.option_select as string[]).includes(
                          select_option_value,
                        )
                      ) {
                        option_value = select_option_value;
                      }
                    }
                  }
                });
                return {
                  ...column,
                  [option.option_name as string]: option_value,
                };
              } else if (option.option_type === 2) {
                option_value = [];
                toss_up_option_data.map((toss_up_option) => {
                  if (
                    toss_up_option.option_name === option.option_name &&
                    toss_up_option.option_type === 2
                  ) {
                    // 質問名が同じなら同じ値を挿入
                    if (
                      (option.option_name as string) in addData.customerInfo
                    ) {
                      let select_option_values = addData.customerInfo[
                        option.option_name as string
                      ] as string[];
                      select_option_values.map(
                        (select_option_value: string) => {
                          if (
                            (option.option_select as string[]).includes(
                              select_option_value,
                            )
                          ) {
                            (option_value as string[]).push(
                              select_option_value,
                            );
                          }
                        },
                      );
                    }
                  }
                });
                return {
                  ...column,
                  [option.option_name as string]: option_value,
                };
              } else if (option.option_type === 3) {
                option_value = "";
                toss_up_option_data.map((toss_up_option) => {
                  if (
                    toss_up_option.option_name === option.option_name &&
                    toss_up_option.option_type === 3
                  ) {
                    // 質問名が同じなら同じ値を挿入
                    if (
                      (option.option_name as string) in addData.customerInfo
                    ) {
                      option_value = addData.customerInfo[
                        option.option_name as string
                      ] as string;
                    }
                  }
                });
                return {
                  ...column,
                  [option.option_name as string]: option_value,
                };
              } else if (option.option_type === 4) {
                // 画像の自動は一旦なし
                return {
                  ...column,
                  [option.option_name as string]: "",
                };
              } else {
                return {
                  ...column,
                  [option.option_name as string]: "",
                };
              }
            },
            {},
          );
          let addressOptionName = "";
          option_data.map((uniqueOptin) => {
            if (uniqueOptin.address_flg) {
              addressOptionName = uniqueOptin.option_name as string;
            }
          });
          setAddressOptionName(addressOptionName);
          setAddData((addData) => ({
            ...addData,
            customerInfo,
            addStatus: "contract",
            productId,
            productName,
            outSiteEntry,
          }));
        } else {
          swCloseModal();
          setOnDataAddModalResult(
            "エントリーフォームが定義されていません。管理者に問い合わせてください。",
          );
        }
      }
    } else if (outSiteEntry === 1) {
      // 外部エントリー
      setOutSidePullDownServiceNameList(outside_pull_down_service);
      setOutSideCheckBoxServiceNameList(outside_check_box_service);
      setSmsMessagePatterns(outside_sms_patterns);
      setMailMessagePatterns(outside_mail_patterns);
      if (outside_option_data.length > 0) {
        const customerInfo: {
          [key: string]: string | string[];
        } = outside_option_data.reduce<{ [key: string]: string | string[] }>(
          (column, option) => {
            let option_value: string | string[] = "";
            // change_value_conf===1 は option_type0(default非空)前提
            if (option.change_value_conf === 1) {
              return { ...column, [option.option_name as string]: (option.option_default_value as string) ?? "" };
            }
            if (option.option_type === 0) {
              option_value = option.option_default_value as string;
              let tel_flg_option_name = "";
              let name_flg_option_name = "";
              let company_name_flg_option_name = "";
              let zip_code_flg_option_name = "";
              let address_flg_option_name = "";
              let mail_address_flg_option_name = "";
              toss_up_option_data.map((toss_up_option) => {
                if (
                  toss_up_option.option_name === option.option_name &&
                  toss_up_option.option_type === 0
                ) {
                  // 質問名が同じなら同じ値を挿入
                  if ((option.option_name as string) in addData.customerInfo) {
                    option_value =
                      addData.customerInfo[option.option_name as string];
                  }
                }
                // 重複なしの各種フラグが同じなら質問名に関わらず同じ値を挿入
                if (toss_up_option.tel_flg === 1) {
                  tel_flg_option_name = toss_up_option.option_name as string;
                }
                if (toss_up_option.name_flg === 1) {
                  name_flg_option_name = toss_up_option.option_name as string;
                }
                if (toss_up_option.company_name_flg === 1) {
                  company_name_flg_option_name =
                    toss_up_option.option_name as string;
                }
                if (toss_up_option.zip_code_flg === 1) {
                  zip_code_flg_option_name =
                    toss_up_option.option_name as string;
                }
                if (toss_up_option.address_flg === 1) {
                  address_flg_option_name =
                    toss_up_option.option_name as string;
                }
                if (toss_up_option.mail_address_flg === 1) {
                  mail_address_flg_option_name =
                    toss_up_option.option_name as string;
                }
              });
              if (option.tel_flg === 1 && tel_flg_option_name != "") {
                option_value = addData.customerInfo[tel_flg_option_name];
              }
              if (option.name_flg === 1 && name_flg_option_name != "") {
                option_value = addData.customerInfo[name_flg_option_name];
              }
              if (
                option.company_name_flg === 1 &&
                company_name_flg_option_name != ""
              ) {
                option_value =
                  addData.customerInfo[company_name_flg_option_name];
              }
              if (option.zip_code_flg === 1 && zip_code_flg_option_name != "") {
                option_value = addData.customerInfo[zip_code_flg_option_name];
              }
              if (option.address_flg === 1 && address_flg_option_name != "") {
                option_value = addData.customerInfo[address_flg_option_name];
              }
              if (
                option.mail_address_flg === 1 &&
                mail_address_flg_option_name != ""
              ) {
                option_value =
                  addData.customerInfo[mail_address_flg_option_name];
              }
              return {
                ...column,
                [option.option_name as string]: option_value,
              };
            } else if (option.option_type === 1) {
              toss_up_option_data.map((toss_up_option) => {
                if (
                  toss_up_option.option_name === option.option_name &&
                  toss_up_option.option_type === 1
                ) {
                  // 質問名が同じなら同じ値を挿入
                  if ((option.option_name as string) in addData.customerInfo) {
                    let select_option_value = addData.customerInfo[
                      option.option_name as string
                    ] as string;
                    if (
                      (option.option_select as string[]).includes(
                        select_option_value,
                      )
                    ) {
                      option_value = select_option_value;
                    }
                  }
                }
              });
              return {
                ...column,
                [option.option_name as string]: option_value,
              };
            } else if (option.option_type === 2) {
              option_value = [];
              toss_up_option_data.map((toss_up_option) => {
                if (
                  toss_up_option.option_name === option.option_name &&
                  toss_up_option.option_type === 2
                ) {
                  // 質問名が同じなら同じ値を挿入
                  if ((option.option_name as string) in addData.customerInfo) {
                    let select_option_values = addData.customerInfo[
                      option.option_name as string
                    ] as string[];
                    select_option_values.map((select_option_value: string) => {
                      if (
                        (option.option_select as string[]).includes(
                          select_option_value,
                        )
                      ) {
                        (option_value as string[]).push(select_option_value);
                      }
                    });
                  }
                }
              });
              return {
                ...column,
                [option.option_name as string]: option_value,
              };
            } else if (option.option_type === 3) {
              option_value = "";
              toss_up_option_data.map((toss_up_option) => {
                if (
                  toss_up_option.option_name === option.option_name &&
                  toss_up_option.option_type === 3
                ) {
                  // 質問名が同じなら同じ値を挿入
                  if ((option.option_name as string) in addData.customerInfo) {
                    option_value = addData.customerInfo[
                      option.option_name as string
                    ] as string;
                  }
                }
              });
              return {
                ...column,
                [option.option_name as string]: option_value,
              };
            } else if (option.option_type === 4) {
              // 画像の自動は一旦なし
              return {
                ...column,
                [option.option_name as string]: "",
              };
            } else {
              return {
                ...column,
                [option.option_name as string]: "",
              };
            }
          },
          {},
        );
        let addressOptionName = "";
        let mail_address_flg_use = false;
        outside_option_data.map((uniqueOptin) => {
          if (uniqueOptin.address_flg) {
            addressOptionName = uniqueOptin.option_name as string;
          }
          if (uniqueOptin.mail_address_flg_use) {
            mail_address_flg_use = true;
          }
        });
        setUseMailAddressFlg(mail_address_flg_use);
        setUniqueOptinList(outside_option_data);
        setAddressOptionName(addressOptionName);
        setAddData((addData) => ({
          ...addData,
          customerInfo,
          addStatus: "contract",
          productId,
          productName,
          site_path,
          outSiteEntry,
        }));
      } else {
        swCloseModal();
        setOnDataAddModalResult(
          "外部ETフォームが定義されていません。管理者に問い合わせてください。",
        );
      }
    }
  }

  const [onPostBottun, setOnPostBottun] = useState(false);
  useEffect(() => {
    if (addData.addStatus !== null && addData.addStatus !== "loading") {
      let onPostBottun = true;
      // 内部エントリーの時のみ依存関係確認
      if (addData.outSiteEntry == 0) {
        uniqueOptinList.map((uniqueOptin) => {
          const service_plan_names = uniqueOptin.service_plan_names as string[];
          const service_content_names =
            uniqueOptin.service_content_names as string[];
          const depend_option_name = uniqueOptin.depend_option_name as string;
          const depend_select_names =
            uniqueOptin.depend_select_names as string[];
          const depend_option_value = addData.customerInfo[depend_option_name];
          if (
            uniqueOptin.required_optional === 1 &&
            (service_plan_names.length === 0 ||
              service_plan_names.includes(addData.servicePlanName)) &&
            (service_content_names.length === 0 ||
              service_content_names.some((item) =>
                addData.serviceContentNameList.includes(item),
              )) &&
            (depend_option_name === "他質問に依存しない" ||
              (typeof depend_option_value === "string" &&
                depend_select_names.includes(depend_option_value as string)) ||
              (typeof depend_option_value === "object" &&
                depend_select_names.some((item) =>
                  depend_option_value.includes(item),
                )))
          ) {
            if (
              uniqueOptin.option_type === 0 ||
              uniqueOptin.option_type === 1 ||
              uniqueOptin.option_type === 3
            ) {
              const customerInfoValue = addData.customerInfo[
                uniqueOptin.option_name as string
              ] as string;
              if (
                customerInfoValue === undefined ||
                customerInfoValue === "" ||
                customerInfoValue === " " ||
                customerInfoValue === "--"
              ) {
                onPostBottun = false;
              }
            } else if (uniqueOptin.option_type === 2) {
              const customerInfoValue = addData.customerInfo[
                uniqueOptin.option_name as string
              ] as string[];
              if (customerInfoValue.length === 0) {
                onPostBottun = false;
              }
            } else if (uniqueOptin.option_type === 4) {
              if (!postPictures[uniqueOptin.option_name as string]) {
                onPostBottun = false;
              }
            }
          }
        });

        if (addData.servicePlanName === "") {
          onPostBottun = false;
        }
        if (
          selectServisePaymentList.length > 0 &&
          addData.servicePaymentMethodName === ""
        ) {
          onPostBottun = false;
        }
      }
      // 外部ETフォーム
      if (addData.outSiteEntry == 1) {
        // SMS送信情報確認
        if (addData.outsideMessageType === null) {
          onPostBottun = false;
        }
        if (
          (addData.outsideMessageType === 0 ||
            addData.outsideMessageType === 1) &&
          addData.smsMessagePatternID === null
        ) {
          onPostBottun = false;
        }

        // SMS送信の場合は顧客電話番号の確認
        if (addData.outsideMessageType === 0) {
          if (addData.phone_number === "--") {
            onPostBottun = false;
          }
        }

        // メール送信の場合はメールアドレスの確認
        if (addData.outsideMessageType === 1) {
          let mail_address = "@";
          // そもそも質問にメールアドレスが定義されていない場合
          if (useMailAddressFlg === false) {
            mail_address = addData.customerInfo["メールアドレス"] as string;
          }
          uniqueOptinList.map((uniqueOptin) => {
            if (uniqueOptin.mail_address_flg === 1) {
              mail_address = addData.customerInfo[
                uniqueOptin.option_name as string
              ] as string;
            }
          });
          if (mail_address === "@") {
            onPostBottun = false;
          }
        }
      }

      setOnPostBottun(onPostBottun);
    }
  }, [addData, postPictures]);

  // 契約登録前に画像データ格納
  async function postAddContractData() {
    setAddData((addData) => ({
      ...addData,
      addStatus: "loading",
    }));
    let customerInfo = { ...addData.customerInfo };
    const results = await Promise.all(
      uniqueOptinList.map(async (uniqueOption) => {
        if (
          uniqueOption.option_type === 4 &&
          postPictures[uniqueOption.option_name as string]
        ) {
          const postPicture = postPictures[uniqueOption.option_name as string];
          // 著名付きURL(post用)を作成
          const fileName = postPicture.name;
          const date = new Date();
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
          const day = String(date.getDate()).padStart(2, "0");
          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
          const seconds = String(date.getSeconds()).padStart(2, "0");
          const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
          const { presigned_object, destination_key } =
            await getPresignedPostPicture(nowTimeName, fileName);

          // POSTする form に持たせるデータを生成する
          const formData = new FormData();
          for (const key in presigned_object.fields) {
            formData.append(key, presigned_object.fields[key]);
          }
          formData.append("file", postPicture);
          // ファイルをS3にアップロード（S3受理確認）
          const r = await postPresignedPost(presigned_object.url, formData);
          if (r === "seccess") {
            customerInfo[uniqueOption.option_name as string] = destination_key;
          }
          return r;
        }
        return "seccess";
      }),
    );
    if (results.some((r) => r !== "seccess")) {
      const errMap: {[key: string]: string} = {};
      uniqueOptinList.forEach((opt, i) => {
        if (results[i] !== "seccess") {
          errMap[opt.option_name as string] = "画像のアップロードに失敗しました。もう一度お試しください。";
        }
      });
      setPostPicturesError(errMap);
      setAddData((addData) => ({ ...addData, addStatus: "contract" }));
      setOnDataAddModalResult("画像のアップロードに失敗しました。もう一度お試しください");
      return;
    }
    await postAddData(customerInfo);
  }

  // 件D5: クロージング右サイドバー(トスアップ詳細)ゼブラ化 — 描画行カウンタ(DataDetailTable:169同機構・データ行emitごと加算)
  let dataRowIdx = 0;

  return addData.addStatus !== null && addData.addStatus !== "loading" ? (
    <Modal
      open={onModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} key="ClosingModalAllBox" data-testid="closing-tossup-modal">
        {/* sip-head */}
        <Box data-testid="closing-tossup-header" sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: "var(--sp-5)", py: "var(--sp-4)", borderBottom: "1px solid var(--color-border-light, #efefea)", flexShrink: 0 }}>
          <Box data-testid="closing-tossup-title" sx={{ fontSize: 16, fontWeight: 700, color: "var(--color-ai, #1e3a5f)", fontFamily: "var(--font-heading, inherit)" }}>
            クロージング
          </Box>
          {/* R38: 狭幅(<=1000px)かつ詳細ありのとき、入力⇔詳細を行き来するトグル */}
          {isNarrow && !isSmartPhone && dataDetail && (
            <Button
              data-testid="closing-narrow-pane-toggle"
              variant="outlined"
              className="po-btn po-btn-secondary"
              onClick={() =>
                setNarrowPane((prev) => (prev === "input" ? "detail" : "input"))
              }
              sx={{
                textTransform: "none",
                minWidth: "unset",
                boxShadow: "none",
                backgroundColor: "var(--color-white, #ffffff)",
                color: "var(--color-ai, #1e3a5f)",
                border: "1px solid var(--color-border, #e5e5e0)",
                padding: "0 var(--sp-4, 16px)",
                height: "var(--control-h, 36px)",
                ml: "var(--sp-3, 12px)",
                "&:hover": { boxShadow: "none", backgroundColor: "var(--color-white, #ffffff)" },
              }}
            >
              {narrowPane === "input" ? "詳細を見る" : "入力に戻る"}
            </Button>
          )}
          {/* cmd-po_1247: 自前✕(右上クローズIconButton/CloseIcon)を撤去。閉じるは footer「閉じる」(closing-tossup-cancel-button)へ集約 */}
        </Box>
        {/* cl2-layout */}
        <Box data-testid="closing-tossup-layout" sx={{ display: "flex", flex: 1, minHeight: 0 }}>
        {/* R38: 狭幅時は narrowPane==="input" のときだけ左(入力)カラムを描画=自動で全幅 */}
        {(!isNarrow || narrowPane === "input") && (
        <Box
          data-testid="closing-tossup-left"
          sx={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column" }}
          key="ClosingTossUpModalBox"
        >
          {/* sip-stepper ★U8(cmd-po_1109): 共通部品化 */}
          {hasStep1 && (
            <SipStepper
              steps={["担当アカウント", "クロージング判定"]}
              activeIndex={addData.addStatus === "change_account" ? 0 : 1}
              suffix={
                acctName && addData.addStatus !== "change_account" ? (
                  <Box sx={{ fontSize: 11, fontWeight: 600, color: "var(--color-ai, #1e3a5f)", bgcolor: "var(--color-ai-pale, #e8eef4)", borderRadius: "999px", px: 1.5, py: 0.5, whiteSpace: "nowrap" }}>
                    {acctName}
                  </Box>
                ) : undefined
              }
            />
          )}
          {addData.addStatus === "product" ? (
            <>
              <Box sx={{ px: "var(--sp-5, 20px)", pt: "var(--sp-4, 16px)" }}>
                商材検索（部分一致）
                <Box key="searchProductName">
                  <PoTextField
                    id="inputSerchProductName"
                    value={inputSerchProductName}
                    onChange={async (e) => {
                      setInputSerchProductName(e.target.value);
                    }}
                    fullWidth
                  />
                </Box>
              </Box>
            </>
          ) : null}
          {addData.addStatus === "entry_method" ? (
            <Box sx={{ px: "var(--sp-5, 20px)", pt: "var(--sp-4, 16px)" }}>エントリー方法</Box>
          ) : null}
          {addData.addStatus === "site_path" ? (
            <Box sx={{ px: "var(--sp-5, 20px)", pt: "var(--sp-4, 16px)" }}>サイトパス</Box>
          ) : null}
          {addData.addStatus === "open" ? (
            <Typography
              id="modal-modal-description"
              data-testid="closing-tossup-body"
              sx={{ flex: 1, minHeight: 0, overflowY: "auto", px: "var(--sp-5, 20px)", py: "var(--sp-4, 16px)", display: "flex", flexDirection: "column", gap: "var(--sp-4, 16px)" }}
              key="ClosingTossUpModalBoxProject"
            >
              <Paper elevation={0}>
                <Box
                  key="open1"
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "var(--sp-4, 16px)",
                  }}
                >
                  <PoField fieldKey="cellPhone">
                    <PoLabel>顧客電話番号</PoLabel>
                    <PoTextField
                      disabled
                      id="cellPhone"
                      value={addData.phone_number}
                      fullWidth
                    />
                  </PoField>
                  <PoField fieldKey="customer_name">
                    <PoLabel>顧客氏名</PoLabel>
                    <PoTextField
                      disabled
                      id="customer_name"
                      value={addData.customer_name}
                      fullWidth
                    />
                  </PoField>
                  <PoField fieldKey="toss_up_status">
                    <PoLabel required>クロージング結果</PoLabel>
                    <PoSelect
                      fullWidth
                      id="serch-input-option"
                      key={"servicePlanSelect"}
                      value={addData.toss_up_status}
                      onChange={(e) => {
                        const toss_up_status = e.target.value as number;
                        setAddData((addData) => ({
                          ...addData,
                          toss_up_status,
                        }));
                      }}
                    >
                      {LIST_POST.toss_up_status_closing.map((toss_up, i) => {
                        return (
                          <MenuItem
                            key={"toss_up_status_closing" + i}
                            value={toss_up.id}
                            sx={{
                              fontSize: "14px",
                              height: toss_up.value === "" ? "14px" : "24px",
                              minHeight: "auto",
                            }}
                          >
                            {toss_up.value}
                          </MenuItem>
                        );
                      })}
                    </PoSelect>
                  </PoField>
                  {addData.toss_up_status === 1 ? (
                    <>
                      <PoField fieldKey="closing_memo">
                        <PoLabel optional>クロージング備考</PoLabel>
                        <PoTextField
                          id="closing_memo"
                          value={addData.closing_memo}
                          onChange={async (e) => {
                            setAddData((addData) => ({
                              ...addData,
                              closing_memo: e.target.value,
                            }));
                          }}
                          fullWidth
                          multiline
                          rows={4}
                        />
                      </PoField>
                      <PoField fieldKey="copy_toss_up">
                        <PoLabel optional>トスアップの複製</PoLabel>
                        <PoSelect
                          fullWidth
                          id="serch-input-option"
                          key={"servicePlanSelect"}
                          value={addData.copy_toss_up}
                          onChange={(e) => {
                            const copy_toss_up = e.target.value as 0 | 1;
                            setAddData((addData) => ({
                              ...addData,
                              copy_toss_up,
                            }));
                          }}
                        >
                          {LIST_POST.copy_toss_up.map((toss_up, i) => {
                            return (
                              <MenuItem
                                key={"copy_toss_up_box" + i}
                                value={toss_up.id}
                                sx={{
                                  fontSize: "14px",
                                  height:
                                    toss_up.value === "" ? "14px" : "24px",
                                  minHeight: "auto",
                                }}
                              >
                                {toss_up.value}
                              </MenuItem>
                            );
                          })}
                        </PoSelect>
                      </PoField>
                    </>
                  ) : null}
                  {addData.toss_up_status === 7 ||
                  addData.toss_up_status === 10 ? (
                    <>
                      <PoField fieldKey="closing_memo">
                        <PoLabel required>クロージング備考</PoLabel>
                        <PoTextField
                          id="closing_memo"
                          value={addData.closing_memo}
                          onChange={async (e) => {
                            setAddData((addData) => ({
                              ...addData,
                              closing_memo: e.target.value,
                            }));
                          }}
                          fullWidth
                          multiline
                          rows={4}
                        />
                      </PoField>
                    </>
                  ) : null}
                  {addData.toss_up_status === 2 ? (
                    <>
                      <PoField fieldKey="closing_failed_memo_2">
                        <PoLabel required>失敗理由</PoLabel>
                        <PoTextField
                          id="closing_failed_memo"
                          value={addData.closing_failed_memo}
                          onChange={async (e) => {
                            setAddData((addData) => ({
                              ...addData,
                              closing_failed_memo: e.target.value,
                            }));
                          }}
                          fullWidth
                          multiline
                          rows={4}
                        />
                      </PoField>
                    </>
                  ) : null}
                  {addData.toss_up_status === 3 ? (
                    <>
                      <PoField fieldKey="return_call_memo_3">
                        <PoLabel optional>架電備考</PoLabel>
                        <PoTextField
                          id="return_call_memo"
                          value={addData.return_call_memo}
                          onChange={async (e) => {
                            setAddData((addData) => ({
                              ...addData,
                              return_call_memo: e.target.value,
                            }));
                          }}
                          fullWidth
                          multiline
                          rows={4}
                        />
                      </PoField>
                    </>
                  ) : null}
                  {addData.toss_up_status === 4 ? (
                    <>
                      <PoField fieldKey="hope_call_date_4">
                        <PoLabel required>架電希望日</PoLabel>
                        <PoTextField
                          id="hope_call_date"
                          type="date"
                          value={addData.hope_call_date}
                          onChange={async (e) => {
                            setAddData((addData) => ({
                              ...addData,
                              hope_call_date: e.target.value,
                            }));
                          }}
                          fullWidth
                        />
                      </PoField>
                      <PoField fieldKey="hope_call_time_kind_4">
                        <PoLabel required>架電希望タイミング</PoLabel>
                        <PoSelect
                          fullWidth
                          id="serch-input-option"
                          key={"tableColumnKomokuDataSelectTiming"}
                          value={addData.hope_call_time_kind}
                          onChange={(e) => {
                            setAddData((addData) => ({
                              ...addData,
                              hope_call_time_kind: e.target.value as number,
                            }));
                          }}
                        >
                          {LIST_POST.hope_call_time_kind.map((input, i) => {
                            return (
                              <MenuItem
                                key={"tableColumnKomokuDataSelectTiming" + i}
                                value={input.id}
                                sx={{
                                  fontSize: "14px",
                                  height: input.value === "" ? "14px" : "24px",
                                  minHeight: "auto",
                                }}
                              >
                                {input.value}
                              </MenuItem>
                            );
                          })}
                        </PoSelect>
                      </PoField>
                      {addData.hope_call_time_kind === 1 ? (
                        <PoField fieldKey="hope_call_time_4">
                          <PoLabel required>架電希望時間</PoLabel>
                          <PoSplit>
                            <PoSelect
                              key={"tableColumnKomokuDataSelectTimingHour4"}
                              value={addData.hope_call_time.split("-")[0]}
                              onChange={(e) => {
                                setAddData((addData) => ({
                                  ...addData,
                                  hope_call_time:
                                    (e.target.value as string) +
                                    "-" +
                                    addData.hope_call_time.split("-")[1],
                                }));
                              }}
                            >
                              {LIST.hope_call_time_hour.map((time, i) => {
                                return (
                                  <MenuItem
                                    key={"tableColumnKomokuDataSelectTiming" + i}
                                    value={time}
                                    sx={{
                                      fontSize: "14px",
                                      height: time === "" ? "14px" : "24px",
                                      minHeight: "auto",
                                    }}
                                  >
                                    {time}
                                  </MenuItem>
                                );
                              })}
                            </PoSelect>
                            <PoSelect
                              key={"tableColumnKomokuDataSelectTimingMinute4"}
                              value={addData.hope_call_time.split("-")[1]}
                              onChange={(e) => {
                                setAddData((addData) => ({
                                  ...addData,
                                  hope_call_time:
                                    addData.hope_call_time.split("-")[0] +
                                    "-" +
                                    (e.target.value as string),
                                }));
                              }}
                            >
                              {LIST.hope_call_time_minute.map((time, i) => {
                                return (
                                  <MenuItem
                                    key={"tableColumnKomokuDataSelectTiming" + i}
                                    value={time}
                                    sx={{
                                      fontSize: "14px",
                                      height: time === "" ? "14px" : "24px",
                                      minHeight: "auto",
                                    }}
                                  >
                                    {time}
                                  </MenuItem>
                                );
                              })}
                            </PoSelect>
                          </PoSplit>
                        </PoField>
                      ) : null}
                      <PoField fieldKey="return_call_memo_4">
                        <PoLabel optional>架電備考</PoLabel>
                        <PoTextField
                          id="return_call_memo"
                          value={addData.return_call_memo}
                          onChange={async (e) => {
                            setAddData((addData) => ({
                              ...addData,
                              return_call_memo: e.target.value,
                            }));
                          }}
                          fullWidth
                          multiline
                          rows={4}
                        />
                      </PoField>
                    </>
                  ) : null}
                  {addData.toss_up_status === 5 ? (
                    <>
                      <PoField fieldKey="hope_call_date_5">
                        <PoLabel required>架電希望日</PoLabel>
                        <PoTextField
                          id="hope_call_date"
                          type="date"
                          value={addData.hope_call_date}
                          onChange={async (e) => {
                            setAddData((addData) => ({
                              ...addData,
                              hope_call_date: e.target.value,
                            }));
                          }}
                          fullWidth
                        />
                      </PoField>
                      <PoField fieldKey="hope_call_time_kind_5">
                        <PoLabel required>架電希望タイミング</PoLabel>
                        <PoSelect
                          fullWidth
                          id="serch-input-option"
                          key={"tableColumnKomokuDataSelectTiming"}
                          value={addData.hope_call_time_kind}
                          onChange={(e) => {
                            setAddData((addData) => ({
                              ...addData,
                              hope_call_time_kind: e.target.value as number,
                            }));
                          }}
                        >
                          {LIST_POST.hope_call_time_kind.map((input, i) => {
                            return (
                              <MenuItem
                                key={"tableColumnKomokuDataSelectTiming" + i}
                                value={input.id}
                                sx={{
                                  fontSize: "14px",
                                  height: input.value === "" ? "14px" : "24px",
                                  minHeight: "auto",
                                }}
                              >
                                {input.value}
                              </MenuItem>
                            );
                          })}
                        </PoSelect>
                      </PoField>
                      {addData.hope_call_time_kind === 1 ? (
                        <PoField fieldKey="hope_call_time_5">
                          <PoLabel required>架電希望時間</PoLabel>
                          <PoSplit>
                            <PoSelect
                              key={"tableColumnKomokuDataSelectTimingHour5"}
                              value={addData.hope_call_time.split("-")[0]}
                              onChange={(e) => {
                                setAddData((addData) => ({
                                  ...addData,
                                  hope_call_time:
                                    (e.target.value as string) +
                                    "-" +
                                    addData.hope_call_time.split("-")[1],
                                }));
                              }}
                            >
                              {LIST.hope_call_time_hour.map((time, i) => {
                                return (
                                  <MenuItem
                                    key={"tableColumnKomokuDataSelectTiming" + i}
                                    value={time}
                                    sx={{
                                      fontSize: "14px",
                                      height: time === "" ? "14px" : "24px",
                                      minHeight: "auto",
                                    }}
                                  >
                                    {time}
                                  </MenuItem>
                                );
                              })}
                            </PoSelect>
                            <PoSelect
                              key={"tableColumnKomokuDataSelectTimingMinute5"}
                              value={addData.hope_call_time.split("-")[1]}
                              onChange={(e) => {
                                setAddData((addData) => ({
                                  ...addData,
                                  hope_call_time:
                                    addData.hope_call_time.split("-")[0] +
                                    "-" +
                                    (e.target.value as string),
                                }));
                              }}
                            >
                              {LIST.hope_call_time_minute.map((time, i) => {
                                return (
                                  <MenuItem
                                    key={"tableColumnKomokuDataSelectTiming" + i}
                                    value={time}
                                    sx={{
                                      fontSize: "14px",
                                      height: time === "" ? "14px" : "24px",
                                      minHeight: "auto",
                                    }}
                                  >
                                    {time}
                                  </MenuItem>
                                );
                              })}
                            </PoSelect>
                          </PoSplit>
                        </PoField>
                      ) : null}
                      <PoField fieldKey="return_call_memo_5">
                        <PoLabel optional>架電備考</PoLabel>
                        <PoTextField
                          id="return_call_memo"
                          value={addData.return_call_memo}
                          onChange={async (e) => {
                            setAddData((addData) => ({
                              ...addData,
                              return_call_memo: e.target.value,
                            }));
                          }}
                          fullWidth
                          multiline
                          rows={4}
                        />
                      </PoField>
                    </>
                  ) : null}
                  {addData.toss_up_status === 6 ? (
                    <>
                      <PoField fieldKey="closing_failed_memo_6">
                        <PoLabel required>対象外理由</PoLabel>
                        <PoTextField
                          id="closing_failed_memo"
                          value={addData.closing_failed_memo}
                          onChange={async (e) => {
                            setAddData((addData) => ({
                              ...addData,
                              closing_failed_memo: e.target.value,
                            }));
                          }}
                          fullWidth
                          multiline
                          rows={4}
                        />
                      </PoField>
                    </>
                  ) : null}
                  {addData.toss_up_status === 8 ? (
                    <>
                      <PoField fieldKey="closing_failed_memo_8">
                        <PoLabel required>条件期間外理由</PoLabel>
                        <PoTextField
                          id="closing_failed_memo"
                          value={addData.closing_failed_memo}
                          onChange={async (e) => {
                            setAddData((addData) => ({
                              ...addData,
                              closing_failed_memo: e.target.value,
                            }));
                          }}
                          fullWidth
                          multiline
                          rows={4}
                        />
                      </PoField>
                    </>
                  ) : null}
                  {addData.toss_up_status === 9 ? (
                    <>
                      <PoField fieldKey="closing_failed_memo_9">
                        <PoLabel required>長期不出理由</PoLabel>
                        <PoTextField
                          id="closing_failed_memo"
                          value={addData.closing_failed_memo}
                          onChange={async (e) => {
                            setAddData((addData) => ({
                              ...addData,
                              closing_failed_memo: e.target.value,
                            }));
                          }}
                          fullWidth
                          multiline
                          rows={4}
                        />
                      </PoField>
                    </>
                  ) : null}
                </Box>
              </Paper>
              <Box
                key="shozaiSelect"
                data-testid="closing-tossup-footer"
                sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "var(--sp-3)", py: "var(--sp-3)", px: "var(--sp-5)", borderTop: "1px solid var(--color-border-light, #efefea)", flexShrink: 0 }}
              >
                {addData.toss_up_status === 0 ||
                addData.toss_up_status === 1 ? (
                  <Button
                    data-testid="closing-tossup-next-button"
                    disabled={addData.toss_up_status === 1 ? false : true}
                    onClick={() => {
                      if (contractProductList.length === 0) {
                        swCloseModal();
                        setOnDataAddModalResult(
                          "エントリー可能な商材が定義されていません。管理者に問い合わせてください。",
                        );
                      } else {
                        setAddData((addData) => ({
                          ...addData,
                          addStatus: "product",
                        }));
                      }
                    }}
                    variant="contained"
                    className="po-btn po-btn-primary"
                    sx={{
                      textTransform: "none",
                      minWidth: "unset",
                      boxShadow: "none",
                      backgroundColor: "var(--color-ai, #1e3a5f)",
                      color: "var(--color-white, #ffffff)",
                      border: "1px solid transparent",
                      padding: "0 var(--sp-4, 16px)",
                      height: isSmartPhone ? "var(--control-h-sp, 44px)" : "var(--control-h, 36px)",
                      "&:hover": { boxShadow: "none", backgroundColor: "var(--color-ai-light, #2a5a8f)" },
                      "&.Mui-disabled": { bgcolor: "var(--state-disabled-bg, #f0f0ec)", color: "var(--state-disabled-fg, #9ca3af)", cursor: "not-allowed", pointerEvents: "auto" },
                    }}
                  >
                    <Box >次へ</Box>
                  </Button>
                ) : (
                  <Button
                    disabled={
                      addData.toss_up_status === 7 ||
                      addData.toss_up_status === 10
                        ? addData.closing_memo === ""
                          ? true
                          : false
                        : addData.toss_up_status === 2 ||
                            addData.toss_up_status === 6 ||
                            addData.toss_up_status === 8 ||
                            addData.toss_up_status === 9
                          ? addData.closing_failed_memo === ""
                            ? true
                            : false
                          : addData.toss_up_status === 3
                            ? false
                            : addData.toss_up_status === 4 ||
                                addData.toss_up_status === 5
                              ? addData.hope_call_date === "" ||
                                addData.hope_call_time_kind === null ||
                                (addData.hope_call_time_kind === 1 &&
                                  addData.hope_call_time === "")
                                ? true
                                : false
                              : true
                    }
                    data-testid="closing-tossup-update-button"
                    onClick={async () => {
                      await putClosingFailed();
                    }}
                    variant="contained"
                    className="po-btn po-btn-primary"
                    sx={{
                      textTransform: "none",
                      minWidth: "unset",
                      boxShadow: "none",
                      backgroundColor: "var(--color-ai, #1e3a5f)",
                      color: "var(--color-white, #ffffff)",
                      border: "1px solid transparent",
                      padding: "0 var(--sp-4, 16px)",
                      height: isSmartPhone ? "var(--control-h-sp, 44px)" : "var(--control-h, 36px)",
                      "&:hover": { boxShadow: "none", backgroundColor: "var(--color-ai-light, #2a5a8f)" },
                      "&.Mui-disabled": { bgcolor: "var(--state-disabled-bg, #f0f0ec)", color: "var(--state-disabled-fg, #9ca3af)", cursor: "not-allowed", pointerEvents: "auto" },
                    }}
                  >
                    <Box >更新</Box>
                  </Button>
                )}
                <Button
                  data-testid="closing-tossup-cancel-button"
                  variant="outlined"
                  className="po-btn po-btn-secondary"
                  sx={{
                    textTransform: "none",
                    minWidth: "unset",
                    boxShadow: "none",
                    backgroundColor: "var(--color-white, #ffffff)",
                    color: "var(--color-ai, #1e3a5f)",
                    border: "1px solid var(--color-border, #e5e5e0)",
                    padding: "0 var(--sp-4, 16px)",
                    height: isSmartPhone ? "var(--control-h-sp, 44px)" : "var(--control-h, 36px)",
                    "&:hover": { boxShadow: "none", backgroundColor: "var(--color-white, #ffffff)" },
                  }}
                  onClick={() => {
                    cancellCloseModal();
                  }}
                >
                  <Box>閉じる</Box>
                </Button>
              </Box>
            </Typography>
          ) : null}
          {addData.addStatus === "product" ? (
            <Typography
              id="modal-modal-description"
              data-testid="closing-tossup-body"
              sx={{ flex: 1, minHeight: 0, overflowY: "auto", px: "var(--sp-5, 20px)", py: "var(--sp-4, 16px)", display: "flex", flexDirection: "column", gap: "var(--sp-4, 16px)" }}
              key="ClosingTossUpModalBoxProject"
            >
              <Paper elevation={0}>
                <Box
                  key="shozai1"
                >
                  <Box
                    key="shozaiClick"
                    sx={{ display: "flex", flexWrap: "wrap" }}
                  >
                    {serchProductList.map((product, i) => {
                      return (
                        <Box
                          sx={{
                            marginTop: "10px",
                            height: "40px",
                            width:
                              !isSmartPhone
                                ? "calc(50% - 10px)"
                                : "calc(100% - 10px)",
                            marginLeft:
                              !isSmartPhone && i % 2 !== 0 ? "10px" : "0",
                          }}
                        >
                          <Button
                            variant="contained"
                            sx={{
                              height: "40px",
                              width: "100%",
                              textTransform: "none",
                            }}
                            onClick={async () => {
                              const productId = product.id;
                              const productName = product.product_name;
                              const have_entry_form = product.have_entry_form;
                              const site_path_list = product.site_path_list;
                              if (site_path_list.length > 0) {
                                setAddData((addData) => ({
                                  ...addData,
                                  addStatus: "entry_method",
                                  productId,
                                  productName,
                                  have_entry_form,
                                  site_path_list,
                                }));
                              } else {
                                await getProductInfo(
                                  productId,
                                  productName,
                                  0,
                                  "",
                                );
                              }
                            }}
                          >
                            <Box >
                              {product.product_name}
                            </Box>
                          </Button>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              </Paper>
              <Box
                key="shozaiSelect"
                data-testid="closing-tossup-footer"
                sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "var(--sp-3)", py: "var(--sp-3)", px: "var(--sp-5)", borderTop: "1px solid var(--color-border-light, #efefea)", flexShrink: 0 }}
              >
                <Button
                  variant="outlined"
                  className="po-btn po-btn-secondary"
                  sx={{
                    textTransform: "none",
                    minWidth: "unset",
                    boxShadow: "none",
                    backgroundColor: "var(--color-white, #ffffff)",
                    color: "var(--color-ai, #1e3a5f)",
                    border: "1px solid var(--color-border, #e5e5e0)",
                    padding: "0 var(--sp-4, 16px)",
                    height: isSmartPhone ? "var(--control-h-sp, 44px)" : "var(--control-h, 36px)",
                    "&:hover": { boxShadow: "none", backgroundColor: "var(--color-white, #ffffff)" },
                  }}
                  onClick={() =>
                    setAddData((addData) => ({
                      ...addData,
                      addStatus: "open",
                    }))
                  }
                >
                  <Box>戻る</Box>
                </Button>
              </Box>
            </Typography>
          ) : addData.addStatus === "entry_method" ? (
            <Typography
              key="ContractAddModalBoxContract"
              id="modal-modal-description"
              data-testid="closing-tossup-body"
              sx={{ flex: 1, minHeight: 0, overflowY: "auto", px: "var(--sp-5, 20px)", py: "var(--sp-4, 16px)", display: "flex", flexDirection: "column", gap: "var(--sp-4, 16px)" }}
            >
              <Paper elevation={0}>
                <Box
                  key="contract1"
                >
                  <Box
                    key="shozaiClick"
                    sx={{ display: "flex", flexWrap: "wrap" }}
                  >
                    <Box
                      sx={{
                        marginTop: "10px",
                        height: "40px",
                        width:
                          !isSmartPhone
                            ? "calc(50% - 5px)"
                            : "calc(100% - 10px)",
                        marginLeft: "0px",
                      }}
                    >
                      <Button
                        disabled={addData.have_entry_form === 0}
                        variant="contained"
                        sx={{
                          height: "40px",
                          width: "100%",
                          textTransform: "none",
                          "&.Mui-disabled": { bgcolor: "var(--state-disabled-bg, #f0f0ec)", color: "var(--state-disabled-fg, #9ca3af)", cursor: "not-allowed", pointerEvents: "auto" },
                        }}
                        onClick={async () => {
                          await getProductInfo(
                            addData.productId as number,
                            addData.productName,
                            0,
                            "",
                          );
                        }}
                      >
                        <Box >
                          エントリー
                        </Box>
                      </Button>
                    </Box>
                    <Box
                      sx={{
                        marginTop: "10px",
                        height: "40px",
                        width:
                          !isSmartPhone
                            ? "calc(50% - 5px)"
                            : "calc(100% - 10px)",
                        marginLeft: "10px",
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{
                          height: "40px",
                          width: "100%",
                          textTransform: "none",
                        }}
                        onClick={async () => {
                          if (addData.site_path_list.length === 1) {
                            await getProductInfo(
                              addData.productId as number,
                              addData.productName,
                              1,
                              addData.site_path_list[0],
                            );
                          } else {
                            setAddData((addData) => ({
                              ...addData,
                              addStatus: "site_path",
                            }));
                          }
                        }}
                      >
                        <Box >
                          外部URL作成
                        </Box>
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Paper>
              <Box
                key="shozaiSelect"
                data-testid="closing-tossup-footer"
                sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "var(--sp-3)", py: "var(--sp-3)", px: "var(--sp-5)", borderTop: "1px solid var(--color-border-light, #efefea)", flexShrink: 0 }}
              >
                <Button
                  variant="outlined"
                  className="po-btn po-btn-secondary"
                  sx={{
                    textTransform: "none",
                    minWidth: "unset",
                    boxShadow: "none",
                    backgroundColor: "var(--color-white, #ffffff)",
                    color: "var(--color-ai, #1e3a5f)",
                    border: "1px solid var(--color-border, #e5e5e0)",
                    padding: "0 var(--sp-4, 16px)",
                    height: isSmartPhone ? "var(--control-h-sp, 44px)" : "var(--control-h, 36px)",
                    "&:hover": { boxShadow: "none", backgroundColor: "var(--color-white, #ffffff)" },
                  }}
                  onClick={() => {
                    setAddData((addData) => ({
                      ...addData,
                      addStatus: "product",
                    }));
                  }}
                >
                  <Box>戻る</Box>
                </Button>
              </Box>
            </Typography>
          ) : addData.addStatus === "site_path" ? (
            <Typography
              key="ContractAddModalBoxContract_site_path"
              id="modal-modal-description"
              data-testid="closing-tossup-body"
              sx={{ flex: 1, minHeight: 0, overflowY: "auto", px: "var(--sp-5, 20px)", py: "var(--sp-4, 16px)", display: "flex", flexDirection: "column", gap: "var(--sp-4, 16px)" }}
            >
              <Paper elevation={0}>
                <Box
                  key="contract1_site_path"
                >
                  <Box
                    key="shozaiClick_site_path"
                    sx={{ display: "flex", flexWrap: "wrap" }}
                  >
                    {addData.site_path_list.map((site_path, i) => {
                      return (
                        <Box
                          sx={{
                            marginTop: "10px",
                            height: "40px",
                            width:
                              !isSmartPhone
                                ? "calc(50% - 5px)"
                                : "calc(100% - 10px)",
                            marginLeft:
                              !isSmartPhone && i % 2 !== 0 ? "10px" : "0",
                          }}
                        >
                          <Button
                            variant="contained"
                            sx={{
                              height: "40px",
                              width: "100%",
                              textTransform: "none",
                            }}
                            onClick={async () => {
                              await getProductInfo(
                                addData.productId as number,
                                addData.productName,
                                1,
                                site_path,
                              );
                            }}
                          >
                            <Box >
                              {site_path}
                            </Box>
                          </Button>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              </Paper>
              <Box
                key="shozaiSelect"
                data-testid="closing-tossup-footer"
                sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "var(--sp-3)", py: "var(--sp-3)", px: "var(--sp-5)", borderTop: "1px solid var(--color-border-light, #efefea)", flexShrink: 0 }}
              >
                <Button
                  variant="outlined"
                  className="po-btn po-btn-secondary"
                  sx={{
                    textTransform: "none",
                    minWidth: "unset",
                    boxShadow: "none",
                    backgroundColor: "var(--color-white, #ffffff)",
                    color: "var(--color-ai, #1e3a5f)",
                    border: "1px solid var(--color-border, #e5e5e0)",
                    padding: "0 var(--sp-4, 16px)",
                    height: isSmartPhone ? "var(--control-h-sp, 44px)" : "var(--control-h, 36px)",
                    "&:hover": { boxShadow: "none", backgroundColor: "var(--color-white, #ffffff)" },
                  }}
                  onClick={() => {
                    setAddData((addData) => ({
                      ...addData,
                      addStatus: "entry_method",
                    }));
                  }}
                >
                  <Box>戻る</Box>
                </Button>
              </Box>
            </Typography>
          ) : addData.addStatus === "contract" ? (
            <Typography
              key="ClosingTossUpModalBoxContract"
              id="modal-modal-description"
              data-testid="closing-tossup-body"
              sx={{ flex: 1, minHeight: 0, overflowY: "auto", px: "var(--sp-5, 20px)", py: "var(--sp-4, 16px)", display: "flex", flexDirection: "column", gap: "var(--sp-4, 16px)" }}
            >
              <Paper elevation={0}>
                <Box
                  key="contract1"
                  sx={{ display: "flex", flexDirection: "column", gap: "var(--sp-4, 16px)" }}
                >
                  <Box >
                    {addData.productName as string}
                  </Box>
                  {addData.outSiteEntry === 0 ? (
                    <>
                      <PoField fieldKey="servicePlanName">
                        <PoLabel required>プラン</PoLabel>
                        <PoSelect
                          key={"servicePlanSelect"}
                          value={addData.servicePlanName}
                          onChange={(e) => {
                            const servicePlanName = e.target.value as string;
                            setAddData((addData) => ({
                              ...addData,
                              servicePlanName,
                            }));
                          }}
                          fullWidth
                        >
                          {selectServisePlanList.map((service, plan_i) => {
                            return (
                              <MenuItem
                                key={"tableColumnKomokuPlan" + plan_i}
                                value={service.service_name}
                                sx={{
                                  fontSize: "14px",
                                  height:
                                    service.service_name === ""
                                      ? "14px"
                                      : "24px",
                                  minHeight: "auto",
                                }}
                              >
                                {service.service_name}
                              </MenuItem>
                            );
                          })}
                        </PoSelect>
                      </PoField>
                      {selectServiseContentList.length > 0 ? (
                        <PoField key="contractServiceContent" fieldKey="serviceContentNameList">
                          <PoLabel>コンテンツ</PoLabel>
                          <PoCheckGroup>
                            {selectServiseContentList.map((service) => {
                              return (
                                <PoCheckRow key={service.service_name}>
                                  <PoCheckbox
                                    checked={
                                      addData.serviceContentNameList.findIndex(
                                        (serviceName) =>
                                          serviceName === service.service_name,
                                      ) > -1
                                    }
                                    onClick={() => {
                                      let serviceContentNameList =
                                        addData.serviceContentNameList.concat();

                                      if (
                                        addData.serviceContentNameList.findIndex(
                                          (serviceName) =>
                                            serviceName ===
                                            service.service_name,
                                        ) > -1
                                      ) {
                                        serviceContentNameList =
                                          serviceContentNameList.filter(
                                            (serviceName) =>
                                              serviceName !==
                                              service.service_name,
                                          );
                                      } else {
                                        serviceContentNameList.push(
                                          service.service_name,
                                        );
                                      }
                                      setAddData((addData) => ({
                                        ...addData,
                                        serviceContentNameList,
                                      }));
                                    }}
                                  />
                                  {service.service_name}
                                </PoCheckRow>
                              );
                            })}
                          </PoCheckGroup>
                        </PoField>
                      ) : null}
                      {selectServiseCampaignPulldownList.length > 0 ? (
                        <PoField key="serviceeCampaignPulldownLabelBox" fieldKey="serviceCampaignPulldownName">
                          <PoLabel>
                            {selectServiseCampaignCheckboxList.length > 0
                              ? "キャンペーン1"
                              : "キャンペーン"}
                          </PoLabel>
                          <PoSelect
                            key={"serviceCampaignPulldownSelect"}
                            value={addData.serviceCampaignPulldownName}
                            onChange={(e) => {
                              const serviceCampaignPulldownName = e.target
                                .value as string;
                              setAddData((addData) => ({
                                ...addData,
                                serviceCampaignPulldownName,
                              }));
                            }}
                            fullWidth
                          >
                            {selectServiseCampaignPulldownList.map(
                              (service, plan_i) => {
                                return (
                                  <MenuItem
                                    key={
                                      "tableColumnKomokuCampaignPulldown" +
                                      plan_i
                                    }
                                    value={service.service_name}
                                    sx={{
                                      fontSize: "14px",
                                      height:
                                        service.service_name === ""
                                          ? "14px"
                                          : "24px",
                                      minHeight: "auto",
                                    }}
                                  >
                                    {service.service_name}
                                  </MenuItem>
                                );
                              },
                            )}
                          </PoSelect>
                        </PoField>
                      ) : null}
                      {selectServiseCampaignCheckboxList.length > 0 ? (
                        <PoField key="contractServiceCampaignCheckbox" fieldKey="serviceCampaignCheckboxName">
                          <PoLabel>
                            {selectServiseCampaignPulldownList.length > 0
                              ? "キャンペーン2"
                              : "キャンペーン"}
                          </PoLabel>
                          <PoCheckGroup>
                            {selectServiseCampaignCheckboxList.map(
                              (service) => {
                                return (
                                  <PoCheckRow key={service.service_name}>
                                    <PoCheckbox
                                      checked={
                                        addData.serviceCampaignCheckboxName.findIndex(
                                          (serviceName) =>
                                            serviceName ===
                                            service.service_name,
                                        ) > -1
                                      }
                                      onClick={() => {
                                        let serviceCampaignCheckboxName =
                                          addData.serviceCampaignCheckboxName.concat();

                                        if (
                                          addData.serviceCampaignCheckboxName.findIndex(
                                            (serviceName) =>
                                              serviceName ===
                                              service.service_name,
                                          ) > -1
                                        ) {
                                          serviceCampaignCheckboxName =
                                            serviceCampaignCheckboxName.filter(
                                              (serviceName) =>
                                                serviceName !==
                                                service.service_name,
                                            );
                                        } else {
                                          serviceCampaignCheckboxName.push(
                                            service.service_name,
                                          );
                                        }
                                        setAddData((addData) => ({
                                          ...addData,
                                          serviceCampaignCheckboxName,
                                        }));
                                      }}
                                    />
                                    {service.service_name}
                                  </PoCheckRow>
                                );
                              },
                            )}
                          </PoCheckGroup>
                        </PoField>
                      ) : null}
                      <PoField fieldKey="servicePaymentMethodName">
                        {selectServisePaymentList.length > 0 ? (
                          <PoLabel required>支払方法</PoLabel>
                        ) : (
                          <PoLabel optional>支払方法</PoLabel>
                        )}
                        {selectServisePaymentList.length > 0 ? (
                          <PoSelect
                            key={"servicePaymentSelect"}
                            value={addData.servicePaymentMethodName}
                            onChange={(e) => {
                              const servicePaymentMethodName = e.target
                                .value as string;
                              setAddData((addData) => ({
                                ...addData,
                                servicePaymentMethodName,
                              }));
                            }}
                            fullWidth
                          >
                            {selectServisePaymentList.map((payment, plan_i) => {
                              return (
                                <MenuItem
                                  key={"tableColumnKomokuPlan" + plan_i}
                                  value={payment.payment_method}
                                  sx={{
                                    fontSize: "14px",
                                    height:
                                      payment.payment_method === ""
                                        ? "14px"
                                        : "24px",
                                    minHeight: "auto",
                                  }}
                                >
                                  {payment.payment_method}
                                </MenuItem>
                              );
                            })}
                          </PoSelect>
                        ) : (
                          <PoTextField
                            id="textFieldIdPaymentMethod"
                            fullWidth
                            value={addData.servicePaymentMethodName}
                            onChange={async (e) => {
                              setAddData((addData) => ({
                                ...addData,
                                servicePaymentMethodName: e.target.value,
                              }));
                            }}
                          />
                        )}
                      </PoField>
                    </>
                  ) : addData.outSiteEntry === 1 ? (
                    <>
                      <PoField key="outsideMessageType" fieldKey="outsideMessageType">
                        <PoLabel required>外部URL共有方法</PoLabel>
                        <PoSelect
                          key={"outsideMessageTypeID"}
                          value={addData.outsideMessageType}
                          onChange={(e) => {
                            const outsideMessageType = e.target
                              .value as number;
                            setAddData((addData) => ({
                              ...addData,
                              smsMessagePatternID: null,
                              outsideMessageType,
                            }));
                          }}
                          fullWidth
                        >
                          {smsMessagePatterns.length > 0 ? (
                            <MenuItem
                              key={"outsideMessageTypeID_1"}
                              value={0}
                              sx={{
                                fontSize: "14px",
                                height: "24px",
                                minHeight: "auto",
                              }}
                            >
                              SMS送信
                            </MenuItem>
                          ) : null}
                          {mailMessagePatterns.length > 0 ? (
                            <MenuItem
                              key={"outsideMessageTypeID_2"}
                              value={1}
                              sx={{
                                fontSize: "14px",
                                height: "24px",
                                minHeight: "auto",
                              }}
                            >
                              メール送信
                            </MenuItem>
                          ) : null}
                          <MenuItem
                            key={"outsideMessageTypeID_3"}
                            value={2}
                            sx={{
                              fontSize: "14px",
                              height: "24px",
                              minHeight: "auto",
                            }}
                          >
                            QRコード表示
                          </MenuItem>
                        </PoSelect>
                      </PoField>
                      {addData.outsideMessageType === 0 ? (
                        <>
                          <PoField key="smsMessagePatternsBox" fieldKey="smsMessagePatternID">
                            <PoLabel required>SMSメッセージ選択</PoLabel>
                            <PoSelect
                              key={"smsMessagePatternID"}
                              value={addData.smsMessagePatternID}
                              onChange={(e) => {
                                const smsMessagePatternID = e.target
                                  .value as number;
                                setAddData((addData) => ({
                                  ...addData,
                                  smsMessagePatternID,
                                }));
                              }}
                              fullWidth
                            >
                              {smsMessagePatterns.map(
                                (message, message_i) => {
                                  return (
                                    <MenuItem
                                      key={
                                        "tableColumnKomokuPlan" + message_i
                                      }
                                      value={message.id}
                                      sx={{
                                        fontSize: "14px",
                                        height: "24px",
                                        minHeight: "auto",
                                      }}
                                    >
                                      {message.outside_sms_name}
                                    </MenuItem>
                                  );
                                },
                              )}
                            </PoSelect>
                          </PoField>
                          {smsMessagePatterns.map((message) => {
                            if (message.id === addData.smsMessagePatternID) {
                              return (
                                <Box key="smsMessageSampleBox">
                                  <PoField fieldKey="sms_sender">
                                    <PoLabel>SMSメッセージ-送信ID</PoLabel>
                                    <PoTextField
                                      disabled
                                      id="textFieldIdMessageSample"
                                      value={message.outside_sms_sender}
                                      fullWidth
                                    />
                                  </PoField>
                                  <PoField fieldKey="sms_body">
                                    <PoLabel>SMSメッセージ-サンプル</PoLabel>
                                    <PoTextField
                                      disabled
                                      id="textFieldIdMessageSample"
                                      value={message.outside_sms_body}
                                      fullWidth
                                      multiline
                                      rows={5}
                                    />
                                  </PoField>
                                </Box>
                              );
                            }
                          })}
                        </>
                      ) : addData.outsideMessageType === 1 ? (
                        <>
                          <PoField key="mailMessagePatternsBox" fieldKey="mailMessagePatternID">
                            <PoLabel required>メール選択</PoLabel>
                            <PoSelect
                              key={"mailMessagePatternID"}
                              value={addData.smsMessagePatternID}
                              onChange={(e) => {
                                const smsMessagePatternID = e.target
                                  .value as number;
                                setAddData((addData) => ({
                                  ...addData,
                                  smsMessagePatternID,
                                }));
                              }}
                              fullWidth
                            >
                              {mailMessagePatterns.map(
                                (message, message_i) => {
                                  return (
                                    <MenuItem
                                      key={
                                        "tableColumnKomokuPlan" + message_i
                                      }
                                      value={message.id}
                                      sx={{
                                        fontSize: "14px",
                                        height: "24px",
                                        minHeight: "auto",
                                      }}
                                    >
                                      {message.outside_sms_name}
                                    </MenuItem>
                                  );
                                },
                              )}
                            </PoSelect>
                          </PoField>
                          {mailMessagePatterns.map((message) => {
                            if (message.id === addData.smsMessagePatternID) {
                              return (
                                <Box key="mailMessageSampleBox">
                                  <PoField fieldKey="mail_sender">
                                    <PoLabel>メール-送信メールアドレス</PoLabel>
                                    <PoTextField
                                      disabled
                                      id="textFieldIdMessageSample"
                                      value={message.outside_sms_sender}
                                      fullWidth
                                    />
                                  </PoField>
                                  <PoField fieldKey="mail_title">
                                    <PoLabel>メール-タイトル</PoLabel>
                                    <PoTextField
                                      disabled
                                      id="textFieldIdMessageSample"
                                      value={message.outside_sms_title}
                                      fullWidth
                                    />
                                  </PoField>
                                  <PoField fieldKey="mail_body">
                                    <PoLabel>メール-本文</PoLabel>
                                    <PoTextField
                                      disabled
                                      id="textFieldIdMessageSample"
                                      value={message.outside_sms_body}
                                      fullWidth
                                      multiline
                                      rows={5}
                                    />
                                  </PoField>
                                </Box>
                              );
                            }
                          })}
                        </>
                      ) : null}
                      {outSidePullDownServiceNameList.length > 0 ? (
                        <PoField key="pullDowmServiceName" fieldKey="pullDownServiceName">
                          <PoLabel required>サービス（プルダウン）</PoLabel>
                          <PoSelect
                            key={"pullDowmServiceNameID"}
                            value={addData.pullDownServiceName}
                            onChange={(e) => {
                              const pullDownServiceName = e.target
                                .value as string;
                              setAddData((addData) => ({
                                ...addData,
                                pullDownServiceName,
                              }));
                            }}
                            fullWidth
                          >
                            {outSidePullDownServiceNameList.map(
                              (service, i) => {
                                return (
                                  <MenuItem
                                    key={"pullDowmServiceNameID_" + i}
                                    value={service.service_name}
                                    sx={{
                                      fontSize: "14px",
                                      height: "24px",
                                      minHeight: "auto",
                                    }}
                                  >
                                    {service.service_name}
                                  </MenuItem>
                                );
                              },
                            )}
                          </PoSelect>
                        </PoField>
                      ) : null}
                      {outSideCheckBoxServiceNameList.length > 0 ? (
                        <PoField key="contractServiceCheckbox" fieldKey="checkBoxServiceNames">
                          <PoLabel>サービス（チェックボックス）</PoLabel>
                          <PoCheckGroup>
                            {outSideCheckBoxServiceNameList.map((service) => {
                              return (
                                <PoCheckRow key={service.service_name}>
                                  <PoCheckbox
                                    checked={addData.checkBoxServiceNames
                                      .split(",")
                                      .includes(service.service_name)}
                                    onClick={() => {
                                      let checkBoxServiceNamesArray =
                                        addData.checkBoxServiceNames.split(",");
                                      if (
                                        checkBoxServiceNamesArray.includes(
                                          service.service_name,
                                        )
                                      ) {
                                        checkBoxServiceNamesArray =
                                          checkBoxServiceNamesArray.filter(
                                            (_serviceName) =>
                                              _serviceName !==
                                              service.service_name,
                                          );
                                      } else {
                                        checkBoxServiceNamesArray.push(
                                          service.service_name,
                                        );
                                      }
                                      const checkBoxServiceNames =
                                        checkBoxServiceNamesArray.join(",");
                                      setAddData((addData) => ({
                                        ...addData,
                                        checkBoxServiceNames,
                                      }));
                                    }}
                                  />
                                  {service.service_name}
                                </PoCheckRow>
                              );
                            })}
                          </PoCheckGroup>
                        </PoField>
                      ) : null}
                    </>
                  ) : null}
                  <PoField fieldKey="serviseCustomerListID">
                    <PoLabel optional>リストID</PoLabel>
                    <PoTextField
                      id="textFieldIdListID"
                      value={addData.serviseCustomerListID}
                      onChange={async (e) => {
                        setAddData((addData) => ({
                          ...addData,
                          serviseCustomerListID: e.target.value,
                        }));
                      }}
                      fullWidth
                    />
                  </PoField>
                  {uniqueOptinList.map((uniqueOption, option_i) => {
                    const option_selects =
                      uniqueOption.option_select as string[];
                    let option_view = false;

                    if (addData.outSiteEntry == 0) {
                      const service_plan_names =
                        uniqueOption.service_plan_names as string[];
                      const service_content_names =
                        uniqueOption.service_content_names as string[];
                      const depend_option_name =
                        uniqueOption.depend_option_name as string;
                      const depend_select_names =
                        uniqueOption.depend_select_names as string[];
                      const depend_option_value =
                        addData.customerInfo[depend_option_name];
                      option_view =
                        (service_plan_names.length === 0 ||
                          service_plan_names.includes(
                            addData.servicePlanName,
                          )) &&
                        (service_content_names.length === 0 ||
                          service_content_names.some((item) =>
                            addData.serviceContentNameList.includes(item),
                          )) &&
                        (depend_option_name === "他質問に依存しない" ||
                          (typeof depend_option_value === "string" &&
                            depend_select_names.includes(
                              depend_option_value as string,
                            )) ||
                          (typeof depend_option_value === "object" &&
                            depend_select_names.some((item) =>
                              depend_option_value.includes(item),
                            )));
                    } else if (addData.outSiteEntry == 1) {
                      option_view = true;
                    }
                    if (option_view) {
                      return (
                        <PoField key={"optionBox_" + option_i} fieldKey={uniqueOption.option_name as string}>
                          <PoLabel
                            required={
                              addData.outSiteEntry === 0
                                ? uniqueOption.required_optional === 1
                                : addData.outSiteEntry === 1
                                  ? (addData.outsideMessageType === 0 && uniqueOption.tel_flg === 1) ||
                                    (addData.outsideMessageType === 1 && uniqueOption.mail_address_flg === 1)
                                  : false
                            }
                            optional={
                              addData.outSiteEntry === 0
                                ? uniqueOption.required_optional !== 1
                                : false
                            }
                            note={
                              addData.outSiteEntry === 1 &&
                              !((addData.outsideMessageType === 0 && uniqueOption.tel_flg === 1) ||
                                (addData.outsideMessageType === 1 && uniqueOption.mail_address_flg === 1)) &&
                              uniqueOption.outside_form_display === 1
                                ? "外部ET非表示"
                                : undefined
                            }
                          >
                            {uniqueOption.option_name}
                          </PoLabel>
                          {uniqueOption.option_type === 0 ? (
                            uniqueOption.tel_flg === 1 ? (
                              <InputFreeTextTel
                                addData={addData}
                                setAddData={setAddData}
                                uniqueOption={uniqueOption}
                                addressOptionName={addressOptionName}
                              />
                            ) : uniqueOption.name_flg === 1 ? (
                              <InputFreeTextName
                                addData={addData}
                                setAddData={setAddData}
                                uniqueOption={uniqueOption}
                                addressOptionName={addressOptionName}
                              />
                            ) : uniqueOption.company_name_flg === 1 ? (
                              <InputFreeTextCompanyName
                                addData={addData}
                                setAddData={setAddData}
                                uniqueOption={uniqueOption}
                                addressOptionName={addressOptionName}
                              />
                            ) : uniqueOption.zip_code_flg === 1 ? (
                              <InputFreeTextZipCode
                                addData={addData}
                                setAddData={setAddData}
                                uniqueOption={uniqueOption}
                                addressOptionName={addressOptionName}
                              />
                            ) : uniqueOption.space_flg === 1 ? (
                              <InputFreeTextSpace
                                addData={addData}
                                setAddData={setAddData}
                                uniqueOption={uniqueOption}
                                addressOptionName={addressOptionName}
                              />
                            ) : uniqueOption.mail_address_flg === 1 ? (
                              <InputFreeTextMailAddress
                                addData={addData}
                                setAddData={setAddData}
                                uniqueOption={uniqueOption}
                                addressOptionName={addressOptionName}
                              />
                            ) : uniqueOption.half_width_number_flg === 1 ? (
                              <InputFreeTextHalfWidthNumber
                                addData={addData}
                                setAddData={setAddData}
                                uniqueOption={uniqueOption}
                                addressOptionName={addressOptionName}
                              />
                            ) : uniqueOption.form_tel_flg === 1 ? (
                              <InputFreeTextFormTel
                                addData={addData}
                                setAddData={setAddData}
                                uniqueOption={uniqueOption}
                                addressOptionName={addressOptionName}
                              />
                            ) : (
                              <InputFreeText
                                addData={addData}
                                setAddData={setAddData}
                                uniqueOption={uniqueOption}
                                addressOptionName={addressOptionName}
                              />
                            )
                          ) : uniqueOption.option_type === 1 ? (
                            <>
                              <PoSelect
                                key={"tableColumnKomokuDataSelect" + option_i}
                                fullWidth
                                value={
                                  addData.customerInfo[
                                    uniqueOption.option_name as string
                                  ]
                                }
                                onChange={(e) => {
                                  let customerInfo = addData.customerInfo;
                                  customerInfo[
                                    uniqueOption.option_name as string
                                  ] = e.target.value as string;
                                  setAddData((addData) => ({
                                    ...addData,
                                    customerInfo,
                                  }));
                                }}
                              >
                                {option_selects.map(
                                  (option_select: string, select_i) => {
                                    return (
                                      <MenuItem
                                        key={
                                          "tableColumnKomokuMenuItem" +
                                          option_i +
                                          "_" +
                                          select_i
                                        }
                                        value={option_select}
                                        sx={{
                                          fontSize: "14px",
                                          height:
                                            option_select === ""
                                              ? "14px"
                                              : "24px",
                                          minHeight: "auto",
                                        }}
                                      >
                                        {option_select}
                                      </MenuItem>
                                    );
                                  },
                                )}
                              </PoSelect>
                              {uniqueOption.option_comment !== "" ? (
                                <PoHelper>{uniqueOption.option_comment}</PoHelper>
                              ) : null}
                            </>
                          ) : uniqueOption.option_type === 2 ? (
                            <>
                              <PoCheckGroup>
                                {option_selects.map(
                                  (option_select: string, select_i) => {
                                    const customerInfoList = addData.customerInfo[
                                      uniqueOption.option_name as string
                                    ] as string[];
                                    return (
                                      <PoCheckRow
                                        key={
                                          "tableColumnKomokuDataBox" +
                                          option_i +
                                          "_" +
                                          select_i
                                        }
                                      >
                                        <PoCheckbox
                                          checked={
                                            customerInfoList.findIndex(
                                              (_option_select) =>
                                                _option_select === option_select,
                                            ) > -1
                                          }
                                          onClick={() => {
                                            let _customerInfoList =
                                              customerInfoList.concat();
                                            if (
                                              customerInfoList.findIndex(
                                                (_option_select) =>
                                                  _option_select ===
                                                  option_select,
                                              ) > -1
                                            ) {
                                              _customerInfoList =
                                                _customerInfoList.filter(
                                                  (_option_select) =>
                                                    _option_select !==
                                                    option_select,
                                                );
                                            } else {
                                              _customerInfoList.push(
                                                option_select,
                                              );
                                            }
                                            let customerInfo =
                                              addData.customerInfo;
                                            customerInfo[
                                              uniqueOption.option_name as string
                                            ] = _customerInfoList;
                                            setAddData((addData) => ({
                                              ...addData,
                                              customerInfo,
                                            }));
                                          }}
                                        />
                                        {option_select}
                                      </PoCheckRow>
                                    );
                                  },
                                )}
                              </PoCheckGroup>
                              {uniqueOption.option_comment !== "" ? (
                                <PoHelper>{uniqueOption.option_comment}</PoHelper>
                              ) : null}
                            </>
                          ) : uniqueOption.option_type === 3 ? (
                            <>
                              <PoTextField
                                id="textFieldIdDate"
                                fullWidth
                                type="date"
                                value={
                                  addData.customerInfo[
                                    uniqueOption.option_name as string
                                  ]
                                }
                                onChange={async (e) => {
                                  let customerInfo = addData.customerInfo;
                                  customerInfo[
                                    uniqueOption.option_name as string
                                  ] = e.target.value;
                                  setAddData((addData) => ({
                                    ...addData,
                                    customerInfo,
                                  }));
                                }}
                              />
                              {uniqueOption.option_comment !== "" ? (
                                <PoHelper>{uniqueOption.option_comment}</PoHelper>
                              ) : null}
                            </>
                          ) : uniqueOption.option_type === 4 ? (
                            <PoFileDrop
                              inputProps={{
                                id: "textFieldPicture",
                                onChange: (
                                  event_file: React.ChangeEvent<HTMLInputElement>,
                                ) => {
                                  if (
                                    event_file.target.files &&
                                    event_file.target.files.length > 0
                                  ) {
                                    const file = event_file.target.files[0];
                                    const updatedPostPictures = {
                                      ...postPictures,
                                      [uniqueOption.option_name as string]:
                                        file,
                                    };
                                    setPostPicture(updatedPostPictures);
                                  }
                                },
                              }}
                              error={postPicturesError[uniqueOption.option_name as string]}
                              onClear={() => {
                                const updated = { ...postPictures };
                                delete updated[uniqueOption.option_name as string];
                                setPostPicture(updated);
                                setPostPicturesError({ ...postPicturesError, [uniqueOption.option_name as string]: "" });
                              }}
                            />
                          ) : null}
                        </PoField>
                      );
                    }
                  })}
                </Box>
              </Paper>
              <Box
                key="contract7"
                data-testid="closing-tossup-footer"
                sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "var(--sp-3)", py: "var(--sp-3)", px: "var(--sp-5)", borderTop: "1px solid var(--color-border-light, #efefea)", flexShrink: 0 }}
              >
                <Button
                  disabled={!onPostBottun}
                  variant="contained"
                  className="po-btn po-btn-primary"
                  sx={{
                    textTransform: "none",
                    minWidth: "unset",
                    boxShadow: "none",
                    backgroundColor: "var(--color-ai, #1e3a5f)",
                    color: "var(--color-white, #ffffff)",
                    border: "1px solid transparent",
                    padding: "0 var(--sp-4, 16px)",
                    height: isSmartPhone ? "var(--control-h-sp, 44px)" : "var(--control-h, 36px)",
                    "&:hover": { boxShadow: "none", backgroundColor: "var(--color-ai-light, #2a5a8f)" },
                    "&.Mui-disabled": { bgcolor: "var(--state-disabled-bg, #f0f0ec)", color: "var(--state-disabled-fg, #9ca3af)", cursor: "not-allowed", pointerEvents: "auto" },
                  }}
                  onClick={postAddContractData}
                >
                  <Box

                    style={{
                      color: !onPostBottun ? "rgb(70 70 70)" : undefined,
                    }}
                  >
                    {addData.outSiteEntry === 0
                      ? "新規登録"
                      : addData.outsideMessageType === null ||
                          addData.outsideMessageType === 0
                        ? "SMS送信"
                        : addData.outsideMessageType === 1
                          ? "メール送信"
                          : addData.outsideMessageType === 2
                            ? "QRコード表示"
                            : "SMS送信"}
                  </Box>
                  {addData.outSiteEntry === 0 ? (
                    <AddCircleOutlineIcon
                      sx={{
                        marginLeft: "6px",
                        color: !onPostBottun ? "rgb(70 70 70)" : "white",
                      }}
                      fontSize="medium"
                    />
                  ) : (
                    <EmailIcon
                      sx={{
                        marginLeft: "6px",
                        color: !onPostBottun ? "rgb(70 70 70)" : "white",
                      }}
                      fontSize="medium"
                    />
                  )}
                </Button>
                <Button
                  variant="outlined"
                  className="po-btn po-btn-secondary"
                  sx={{
                    textTransform: "none",
                    minWidth: "unset",
                    boxShadow: "none",
                    backgroundColor: "var(--color-white, #ffffff)",
                    color: "var(--color-ai, #1e3a5f)",
                    border: "1px solid var(--color-border, #e5e5e0)",
                    padding: "0 var(--sp-4, 16px)",
                    height: isSmartPhone ? "var(--control-h-sp, 44px)" : "var(--control-h, 36px)",
                    "&:hover": { boxShadow: "none", backgroundColor: "var(--color-white, #ffffff)" },
                  }}
                  onClick={() => {
                    setAddData((addData) => ({
                      ...addData,
                      addStatus: "product",
                      productId: null,
                      productName: "",
                      have_entry_form: null,
                      servicePlanName: "",
                      serviceContentNameList: [],
                      serviceCampaignPulldownName: "",
                      serviceCampaignCheckboxName: [],
                      servicePaymentMethodName: "",
                      serviseCustomerListID: "",
                      pullDownServiceName: "",
                      checkBoxServiceNames: "",
                      smsMessagePatternID: null,
                      customerInfo: {},
                    }));
                    setSelectServisePlanList([]);
                    setSelectServiseContentList([]);
                    setSelectServiseCampaignPulldownList([]);
                    setSelectServiseCampaignCheckboxList([]);
                    setSelectServisePaymentList([]);
                    setUniqueOptinList([]);
                    setAddressOptionName("");
                    setOutSidePullDownServiceNameList([]);
                    setOutSideCheckBoxServiceNameList([]);
                    setSmsMessagePatterns([]);
                    setMailMessagePatterns([]);
                    setUseMailAddressFlg(false);
                  }}
                >
                  <Box>戻る</Box>
                </Button>
              </Box>
            </Typography>
          ) : addData.addStatus === "copyTossUp" ? (
            <>
              <Typography
                id="modal-modal-description"
                data-testid="closing-tossup-body"
                sx={{ flex: 1, minHeight: 0, overflowY: "auto", px: "var(--sp-5, 20px)", py: "var(--sp-4, 16px)", display: "flex", flexDirection: "column", gap: "var(--sp-4, 16px)" }}
                key="ClosingTossUpModalBoxProject"
              >
                <Paper elevation={0}>
                  <Box

                    key="copyTossUp"
                    sx={{ marginTop: "15px", marginBottom: "25px" }}
                  >
                    トスアップのクロージングに成功しました。
                    <br />
                    続けて、トスアップの複製を行います。
                  </Box>
                </Paper>
              </Typography>
              <Box key="shozaiSelect" data-testid="closing-tossup-footer" sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "var(--sp-3)", py: "var(--sp-3)", px: "var(--sp-5)", borderTop: "1px solid var(--color-border-light, #efefea)", flexShrink: 0 }}>
                <Button
                  data-testid="closing-tossup-copy-next-button"
                  variant="contained"
                  className="po-btn po-btn-primary"
                  sx={{
                    textTransform: "none",
                    minWidth: "unset",
                    boxShadow: "none",
                    backgroundColor: "var(--color-ai, #1e3a5f)",
                    color: "var(--color-white, #ffffff)",
                    border: "1px solid transparent",
                    padding: "0 var(--sp-4, 16px)",
                    height: isSmartPhone ? "var(--control-h-sp, 44px)" : "var(--control-h, 36px)",
                    "&:hover": { boxShadow: "none", backgroundColor: "var(--color-ai-light, #2a5a8f)" },
                    "&.Mui-disabled": { bgcolor: "var(--state-disabled-bg, #f0f0ec)", color: "var(--state-disabled-fg, #9ca3af)", cursor: "not-allowed", pointerEvents: "auto" },
                  }}
                  onClick={copyClosingTossUp}
                >
                  <Box >次へ</Box>
                </Button>
              </Box>
            </>
          ) : addData.addStatus === "sms_success" ? (
            <>
              <Typography
                id="modal-modal-description"
                data-testid="closing-tossup-body"
                sx={{ flex: 1, minHeight: 0, overflowY: "auto", px: "var(--sp-5, 20px)", py: "var(--sp-4, 16px)", display: "flex", flexDirection: "column", gap: "var(--sp-4, 16px)" }}
                key="ClosingTossUpModalBoxProject"
              >
                <Paper elevation={0}>
                  <Box
                    key="shozai1"
                  >
                    <Box
                      
                      key="sms_success"
                      sx={{ marginTop: "15px", marginBottom: "5px" }}
                    >
                      {addData.outsideMessageType === 0
                        ? "SMSを送信しました。"
                        : addData.outsideMessageType === 1
                          ? "メールを送信しました。"
                          : addData.outsideMessageType === 2
                            ? "QRコードを表示します。"
                            : ""}
                    </Box>
                    <Box
                      
                      key="sms_success"
                      sx={{
                        marginTop: "25px",
                        marginBottom: "5px",
                        textAlign: "center",
                        display: !isSmartPhone ? "flex" : undefined,
                      }}
                    >
                      <Box
                        sx={{
                          textAlign: "center",
                          width: !isSmartPhone ? 200 : 180,
                          marginLeft:
                            addData.viewOutsideServiceUrl === 1
                              ? !isSmartPhone
                                ? "calc(50% - 210px - 2.5%)"
                                : "auto"
                              : "auto",
                          marginRight:
                            addData.viewOutsideServiceUrl === 1
                              ? !isSmartPhone
                                ? undefined
                                : "auto"
                              : "auto",
                        }}
                      >
                        <Box>
                          エントリーページ
                          <IconButton
                            sx={{
                              height: "25px",
                              width: "25px",
                              marginBottom: "5px",
                            }}
                            aria-label="detail row"
                            size="medium"
                            onClick={() => {
                              const canvas = document.querySelector("canvas");
                              const link = document.createElement("a");
                              if (canvas) {
                                link.href = canvas.toDataURL("image/png");
                                link.download = "qrcode.png";
                                link.click();
                              }
                            }}
                          >
                            <FileDownloadIcon fontSize="medium" />
                          </IconButton>
                        </Box>
                        <Box>
                          <QRCodeCanvas
                            value={addData.outsideSiteUrl}
                            size={!isSmartPhone ? 200 : 180}
                          />
                        </Box>
                      </Box>
                      {addData.viewOutsideServiceUrl === 1 ? (
                        <Box
                          sx={{
                            textAlign: "center",
                            width: !isSmartPhone ? 200 : 180,
                            marginLeft:
                              !isSmartPhone ? "calc(10px + 5%)" : "auto",
                            marginRight: !isSmartPhone ? undefined : "auto",
                            marginTop: !isSmartPhone ? undefined : "25px",
                          }}
                        >
                          <Box>
                            サービスページ
                            <IconButton
                              sx={{
                                height: "25px",
                                width: "25px",
                                marginBottom: "5px",
                              }}
                              aria-label="detail row"
                              size="medium"
                              onClick={() => {
                                const canvas = document.querySelector("canvas");
                                const link = document.createElement("a");
                                if (canvas) {
                                  link.href = canvas.toDataURL("image/png");
                                  link.download = "qrcode.png";
                                  link.click();
                                }
                              }}
                            >
                              <FileDownloadIcon fontSize="medium" />
                            </IconButton>
                          </Box>
                          <Box>
                            <QRCodeCanvas
                              value={addData.outsideServiceUrl}
                              size={!isSmartPhone ? 200 : 180}
                            />
                          </Box>
                        </Box>
                      ) : null}
                    </Box>
                    <Box
                      
                      key="sms_success"
                      sx={{
                        marginTop: "45px",
                        marginBottom: "5px",
                        wordWrap: "break-word",
                        wordBreak: "break-all",
                      }}
                    >
                      エントリーページ: <br />
                      {addData.outsideSiteUrl}
                    </Box>
                    {addData.viewOutsideServiceUrl === 1 ? (
                      <Box
                        
                        key="sms_success"
                        sx={{
                          marginTop: "30px",
                          marginBottom: "5px",
                          wordWrap: "break-word",
                          wordBreak: "break-all",
                        }}
                      >
                        サービスページ: <br />
                        {addData.outsideServiceUrl}
                      </Box>
                    ) : null}
                  </Box>
                </Paper>
              </Typography>
              <Box
                key="shozaiSelect"
                data-testid="closing-tossup-footer"
                sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "var(--sp-3)", py: "var(--sp-3)", px: "var(--sp-5)", borderTop: "1px solid var(--color-border-light, #efefea)", flexShrink: 0 }}
              >
                <Button
                  variant="outlined"
                  className="po-btn po-btn-secondary"
                  sx={{
                    textTransform: "none",
                    minWidth: "unset",
                    boxShadow: "none",
                    backgroundColor: "var(--color-white, #ffffff)",
                    color: "var(--color-ai, #1e3a5f)",
                    border: "1px solid var(--color-border, #e5e5e0)",
                    padding: "0 var(--sp-4, 16px)",
                    height: isSmartPhone ? "var(--control-h-sp, 44px)" : "var(--control-h, 36px)",
                    "&:hover": { boxShadow: "none", backgroundColor: "var(--color-white, #ffffff)" },
                  }}
                  onClick={() => {
                    setAddData((addData) => ({
                      ...addData,
                      addStatus: "contract",
                    }));
                  }}
                >
                  <Box>入力に戻る</Box>
                </Button>
                <Button
                  data-testid="closing-tossup-close-button"
                  variant="contained"
                  className="po-btn po-btn-primary"
                  sx={{
                    textTransform: "none",
                    minWidth: "unset",
                    boxShadow: "none",
                    backgroundColor: "var(--color-ai, #1e3a5f)",
                    color: "var(--color-white, #ffffff)",
                    border: "1px solid transparent",
                    padding: "0 var(--sp-4, 16px)",
                    height: isSmartPhone ? "var(--control-h-sp, 44px)" : "var(--control-h, 36px)",
                    "&:hover": { boxShadow: "none", backgroundColor: "var(--color-ai-light, #2a5a8f)" },
                    "&.Mui-disabled": { bgcolor: "var(--state-disabled-bg, #f0f0ec)", color: "var(--state-disabled-fg, #9ca3af)", cursor: "not-allowed", pointerEvents: "auto" },
                  }}
                  onClick={swCloseModal}
                >
                  <Box >閉じる</Box>
                </Button>
              </Box>
            </>
          ) : null}
        </Box>
        )}
        {dataDetail && !isSmartPhone && (!isNarrow || narrowPane === "detail") ? (
          <Box
            data-testid="closing-tossup-right"
            sx={{
              width: isNarrow ? "100%" : "520px",
              flexShrink: 0,
              borderLeft: "1px solid var(--color-border-light, #f0efea)",
              bgcolor: "var(--color-white, #ffffff)",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* cl2-right-head */}
            <Box
              data-testid="closing-tossup-right-head"
              sx={{
                px: 2,
                py: 1.5,
                fontSize: 13,
                fontWeight: 700,
                color: "var(--color-ai, #1e3a5f)",
                borderBottom: "1px solid var(--color-border-light, #f0efea)",
                fontFamily: "var(--font-heading)",
                flexShrink: 0,
              }}
            >
              トスアップ詳細
            </Box>
            {/* cl2-right-body */}
            <Box data-testid="closing-tossup-right-body" sx={{ flex: 1, overflowY: "auto", padding: "var(--sp-2, 8px) var(--sp-4, 16px) var(--sp-4, 16px)" }}>
              <Box>
                <TableContainer
                  component={Paper}
                  sx={{
                    boxShadow: "none",
                    bgcolor: "var(--color-white, #ffffff)",
                    border: "1px solid var(--color-border, rgb(230, 230, 230))",
                    borderRadius: "var(--radius-md, 10px)",
                  }}
                >
                  <Table
                    stickyHeader
                    aria-label="collapsible table"
                  >
                    <TableHead>
                      <TableRow key="detaiTableRow">
                        <TableCell
                          key={"tableColumnKomoku"}
                          align="left"
                          sx={{
                            width: "38%",
                            fontSize: 11,
                            fontWeight: 600,
                            color: "var(--color-white)",
                            bgcolor: "var(--color-ai)",
                            py: 1,
                            px: 1,
                          }}
                        >
                          質問名
                        </TableCell>
                        <TableCell
                          key={"tableColumnShosai"}
                          align="left"
                          sx={{
                            fontSize: 11,
                            fontWeight: 600,
                            color: "var(--color-white)",
                            bgcolor: "var(--color-ai)",
                            py: 1,
                            px: 1,
                          }}
                        >
                          詳細
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {dataColumn.map((dataColumn, i) => {
                        if (dataColumn.detail) {
                          if (dataColumn.key === "contract_number_months") {
                            return getOneYearListDetail().map(
                              (yearMonth, year_i) => {
                                const rowBg = dataRowIdx++ % 2 === 1 ? "var(--color-ai-pale)" : undefined;
                                return (
                                  <DataDetailRowContractNumberMonths
                                    editAuth={editAuth}
                                    dataColumn={dataColumn}
                                    dataDetail={dataDetail}
                                    dataDetailHistory={[]}
                                    lastContractVersion={0}
                                    year_i={year_i}
                                    yearMonth={yearMonth}
                                    detailType="closing"
                                    rowBg={rowBg}
                                  />
                                );
                              },
                            );
                          } else if (dataColumn.key === "customer_info") {
                            return dataDetailOption.map(
                              (
                                {
                                  option_id,
                                  option_name,
                                  option_type,
                                  tel_flg,
                                  name_flg,
                                  company_name_flg,
                                  multi_text_flg,
                                  entry_method,
                                },
                                option_i,
                              ) => {
                                const customer_info =
                                  dataDetail.customer_info as {
                                    [key: string]: string | string[];
                                  };
                                const optionValue = customer_info[option_name];
                                const rowBg = dataRowIdx++ % 2 === 1 ? "var(--color-ai-pale)" : undefined;
                                return (
                                  <DataDetailRowCustomerInfo
                                    editAuth={editAuth}
                                    dataColumn={dataColumn}
                                    dataDetail={dataDetail}
                                    dataDetailHistory={[]}
                                    lastContractVersion={0}
                                    setEditData={() => {}}
                                    option_i={option_i}
                                    option_id={option_id}
                                    option_name={option_name}
                                    option_type={option_type}
                                    tel_flg={tel_flg}
                                    name_flg={name_flg}
                                    company_name_flg={company_name_flg}
                                    multi_text_flg={multi_text_flg}
                                    entry_method={entry_method}
                                    optionValue={optionValue}
                                    customer_info={customer_info}
                                    detailType="closing"
                                    rowBg={rowBg}
                                  />
                                );
                              },
                            );
                          } else if (
                            ((dataColumn.key === "closing_memo" &&
                              dataDetail["toss_up_status"] ===
                                "クロージング-成功") ||
                              dataColumn.key !== "closing_memo") &&
                            ((dataColumn.key === "closing_failed_memo" &&
                              dataDetail["toss_up_status"] ===
                                "クロージング-失敗") ||
                              dataColumn.key !== "closing_failed_memo") &&
                            ((dataColumn.key === "return_call_memo" &&
                              (dataDetail["toss_up_status"] === "不出" ||
                                dataDetail["toss_up_status"] === "時節" ||
                                dataDetail["toss_up_status"] === "見込み")) ||
                              dataColumn.key !== "return_call_memo")
                          ) {
                            if (
                              loginUser &&
                              dataColumn.tableDetailAuth.includes(
                                loginUser.authority,
                              )
                            ) {
                              const rowBg = dataRowIdx++ % 2 === 1 ? "var(--color-ai-pale)" : undefined;
                              return (
                                <DataDetailRowElse
                                  editAuth={editAuth}
                                  dataDetail={dataDetail}
                                  dataDetailHistory={[]}
                                  lastContractVersion={0}
                                  setEditData={() => {}}
                                  i={i}
                                  dataColumnName={dataColumn.name}
                                  dataColumnKey={dataColumn.key}
                                  dataColumnEdit={dataColumn.edit}
                                  dataColumnEditType={
                                    dataColumn.editType === "outside_site_logo"
                                      ? "outside_site_logo"
                                      : dataColumn.editType ===
                                          "outside_site_favicon"
                                        ? "outside_site_favicon"
                                        : dataColumn.editType === "list"
                                          ? "list"
                                          : dataColumn.editType === "multitext"
                                            ? "multitext"
                                            : "text"
                                  }
                                  dataColumnEditId={dataColumn.editId}
                                  detailTitle={""}
                                  dataColumnTableValue={dataColumn.tableValue}
                                  getGroupList={() => {}}
                                  detailType="closing"
                                  setSelectServiseInfo={() => {}}
                                  setSelectTossUpInfo={() => {}}
                                  rowBg={rowBg}
                                />
                              );
                            }
                          }
                        }
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Box>
          </Box>
        ) : null}
        </Box>
        <LeaveGuard
          open={leaveGuardOpen}
          fieldName=""
          title="担当アカウントの変更"
          message="担当アカウントを変更すると、入力内容がリセットされます。"
          onClose={() => {
            setLeaveGuardOpen(false);
            setAddData((d) => ({ ...d, addStatus: "change_account" }));
          }}
          onReturn={() => setLeaveGuardOpen(false)}
        />
      </Box>
    </Modal>
  ) : null;
}
